export const locale = {
  lang: "it",
  data: {
    SAMPLE: {
      AWESOME: "Create Awesome 🙌",
      CONGRATULATIONS: "Congratulazioni",
      BADGE: "Hai vinto una medaglia d'oro"
    },
    MENU: {
      HOME: "Home",
      PROFILE: "Profilo",
      MANAGE: "Gestione",
      CANDIDATES: "Candidati",
      CANDIDATES_PROPOSED: "Candidati proposti",
      JOB_POSITIONS: "Posizioni",
      JOB_CATEGORIES: "Categorie",
      JOB_SITE: "Modalità",
      RECRUITMENT: "Recruitment",
      REQUEST: "Richieste",
      BARGAINING: "Contrattazioni",
      SITE_PAGES: "Pagine sito",
      CAPABILITY_USER: "Diritti utente",
      USERS: "Gestione utenti",
      EMPLOYEE_LIST: "Dipendenti",
      FUTURE_EMPLOYEE: "Dipendenti futuri",
      RESIGNED_EMPLOYEE: "Dipendenti dimissionari",
      PAYROLLS: "Buste paga",
      CONTRACT_LIST: "Contratti",
      COLLABORATOR_USERS_LIST: "Collaboratori",
      CANDIDATE_LIST: "Candidati",
      EXTERNAL_USERS_LIST: "Fornitori",
      EX_EMPLOYEE_LIST: "Ex dipendenti",
      CONTRACTS_COSTS: "Costi contratti",
      LIST_CONTRACTS_COSTS: "Lista costi contratti",
      UPDATE_CONTRACTS_COSTS: "Aggiorna costi contratti",
      EDUCATION_TITLE: "Titoli di studio",
      CITIES: "Città",
      CONTRACT_TYPES: "Contract",
      ROLES: "Lista ruoli",
      DEPARTMENTS: "Dipartimenti",
      FIGURES: "Figure professionali",
      GROUPS: "Gruppi",
      ABSENCES: "Assenze",
      ABSENCES_TYPE: "Tipi di assenze",
      COMMUNICATIONS: "Comunicazioni",
      LIST_COMMUNICATIONS: "Lista comunicazioni",
      SEND_COMMUNICATION: "Invia comunicazione",
      CATEGORIES_COMMUNICATIONS: "Categorie comunicazioni",
      EDIT_COMMUNICATION: "Modifica comunicazione",
      ABESENCES_REQUESTED_LIST: "Richieste ferie, permessi e malattie",
      ABSENCES_USERS_LIST: "Ferie, Permessi e Malattie",
      ABSENCES_USER: "Le tue richieste di ferie, permessi e malattie",
      NOTIFICATIONS_USER: "Le tue notifiche",
      LIST_NOTIFICATIONS: "Lista notifiche",
      CATEGORIES_NOTIFICATIONS: "Categorie notifiche",
      ANALYTICS: "Analytics",
      NOTIFICATIONS: "Notifiche",
      REFUNDS_REQUESTED_LIST: "Richieste rimborsi",
      REFUNDS: "Rimborsi",
      YOUR_REQUESTED_REFUNDS: "Le tue richieste di rimborso",
      WORKDAY_REPORT: "Rapporto mensile",
      WORKDAY_USER_REPORT: "Rapportino",
      WORKDAY_SEND: "Invia rapportino",
      WORKDAY_USERS_REPORTS: "Rapportini ore mensili",
      YOUR_WORKDAY_REPORT: "Il tuo rapporto mensile",
      CUSTOMERS: "Clienti",
      CUSTOMERS_LOCATION: "Sedi",
      CUSTOMERS_REFERENCE: "Referenti",
      CUSTOMERS_REQUESTS: "Richieste clienti",
      LAST_CUSTOMERS_REQUESTS: "Ultime richieste clienti",
      CREATE_REQUEST: "Crea richiesta",
      DETAIL_REQUEST: "Dettaglio richiesta",
      EDIT_REQUEST: "Modifica richiesta",
      DOCUMENTS: "Documenti",
      DOCUMENTS_CATEGORIES: "Categorie documenti",
      DOCUMENTS_SEND: "Invia documento",
      MY_DOCUMENTS: "I miei documenti",
      DOCUMENTS_LIST: "Lista documenti",
      GENERAL_LISTS: "Liste generali",
      EDIT_BARGAINING: "Modifica contrattazione",
      INVOICE_TYPES: "Tipi di fatture",
      BARGAINING_LIST: "Lista contrattazioni",
      LIST_RESIDUAL_ABSENCES: "Lista assenze residue",
      DOMAIN: "Settori merceologici",
      FIELDS_DB: "Campi database",
      SINGLE_DOMAIN: "Settore merceologico",
      REQUEST_HOLIDAYS: "Richiedi ferie",
      REQUEST_PERMISSION: "Richiedi permesso",
      REQUEST_SICKNESS: "Richiedi malattia",
      ASSETS: "Assets",
      CATEGORIES_EXTRA_HOURS: "Categorie ore extra",
      CAPABILITIES_LIST: "Lista diritti utente",
      ASSIGN_CAPABILITIES: "Assegna diritto utente",
      ADD_CAPABILITIES: "Aggiungi diritto utente",
      ADMINISTRATION: "Amministrazione",
      UPDATE_DATA: "Aggiornamento dati",
      COMMISSIONS_STATS: "Statistiche commesse",
      ADD_FORM_TEMPLATE: "Aggiungi template documento",
      EDIT_FORM_TEMPLATE: "Modifica template documento",
      SUPPORT_REQUEST: "Richiesta di supporto",
      OPEN_SUPPORT_REQUEST: "Apri richiesta di supporto",
      MY_SUPPORT_REQUEST: "Le mie richieste di supporto",
      SUPPORT_REQUEST_LIST: "Lista richieste di supporto",
      CATEGORIES_SUPPORT_REQUEST: "Categorie richieste di supporto",
      MANAGE_SUPPORT_REQUEST: "Gestione richieste di supporto",
      MANAGER_CONTRACT: "Lista template contratti",
      MANAGE_CONTRACT: "Gestisci template contratti",
      ELIGIBLE_CANDIDATE: "Candidati idonei",
      MANAGE_DOCUMENTS: "Gestione documenti",
      LAST_PROPOSED: "Ultimi candidati proposti",
      DOCUMENT_TEMPLATE_LIST: "Lista template documenti",
      TEMPLATE_USER_LIST: "Documenti aziendali dipendenti",
      TUTORIAL: "Tutorial",
      REFUND_KM: "Rimborsi chilometrici",
      TRANSFORMATION: "Trasformazioni",
      DEALS: "Offerte",
      CREATE_DEAL: "Crea offerta",
      EDIT_DEAL: "Modifica offerta",
      SHORTLINKS: "Short links",
      CREATE_COMMISSION: "Crea commessa",
      EDIT_COMMISSION: "Modifica commessa",
      COMMISSION: "Commesse",
      ORDERS: "Ordini",
      PAYMENT_TERMS: "Termini di pagamento",
      PAYMENT_MODE: "Modalità di pagamento",
      ADDRESS_BOOK: "Rubrica",
      INVOICES: "Fatture",
      INVOICES_GENERATED: "Fatture da emettere",
      INVOICES_WORKED: "Fatture emesse",
      INVOICES_CASHED: "Fatture incassate",
      INVOICES_CREDIT_NOTE: "Note di credito",
      BANKS: "Banche",
      INVOICES_EXPIRED: "Fatture scadute",
      CAUSALS: "Causali",
      HIRED_CANDIDATES: "Candidati assunti",
      SIMULATION_CONTRACT_COSTS: "Simulazione costi contratto",
      STATS_CLIENT: "Statistiche clienti",
      ECONOMICS_DATA: "Economics",
      COMMISSIONS: "Commesse",
      SEND_MULTIPLE_WELCOME_EMAIL: "Invio massivo delle email di benvenuto",
      ECONOMIC_BALANCE: "Bilancio economico",
      REFRESH_MONTHLY_ANALYTICS: "Rigenera dettagli economici commesse"
    },
    COMMISSIONS: {
      COMMISSIONS_LIST: "Elenco commesse",
      TIME_INTERVAL: "Intervallo temporale",
      SUMS_OF_COSTS_AND_TURNOVER: "Somme dei costi e dei fatturati",
      JANUARY: "Gen",
      FEBRUARY: "Feb",
      MARCH: "Mar",
      APRIL: "Apr",
      MAY: "Mag",
      JUNE: "Giu",
      JULY: "Lug",
      AUGUST: "Ago",
      SEPTEMBER: "Set",
      OCTOBER: "Ott",
      NOVEMBER: "Nov",
      DECEMBER: "Dic",
      ONE_MONTH: "Un mese",
      THREE_MONTHS: "Tre mesi",
      SIX_MONTHS: "Sei mesi",
      TEWLVE_MONTHS: "Dodici mesi",
      SHOW_TABLE: "Mostra tabella",
      SHOW_CHART: "Mostra grafico",
      EXPORT: "Esporta",
      NAME_OR_EMPLOYEE: "Nome commessa o dipendente"
    },
    TITLES: {
      SUPPORT: "Supporto",
      CURRICULUM: "Curriculum Vitae",
      JOB_POSITIONS: "Posizioni lavorative",
      CAPABILITY_USERS: "Diritti utente",
      USERS: "Utenti",
      PROFILE: "Profilo",
      MANAGE: "Gestione",
      EDIT_PROFILE: "Modifica profilo",
      ADD_CANDIDATE: "Aggiungi candidato",
      ADD_CUSTOMER: "Aggiungi Cliente",
      ADD_SITE: "Aggiungi Sede",
      EDIT_CANDIDATE: "Modifica candidato",
      USERS_TYPES: {
        candidate: "Candidati",
        collaborator: "Collaboratori",
        external: "Fornitori",
        employee: "Dipendenti",
        "ex-employee": "Ex dipendenti",
        ex_employees: "Ex dipendenti",
        proposed: "Proposti",
        suitables: "Idonei"
      },
      USERS_TYPES_SINGULAR: {
        candidate: "Candidato",
        collaborator: "Collaboratore",
        external: "Fornitore",
        employee: "Dipendente",
        "ex-employee": "Ex dipendente",
        stage: "Stagista",
        occasional: "Prestazione occasionale"
      },
      CONTRACTS_COSTS: "Costi contratti",
      UPDATE_CONTRACTS_COSTS: "Modifica costi contratti",
      VIEW_CONTRACTS_COSTS: "Lista costi contratti",
      EDIT_RESIDUAL_ABSENCES: "Modifica assenze residue",
      FUTURE_EMPLOYEE: "Dipendenti futuri",
      EMPLOYEE_ADDRESS_BOOK: "Rubrica dipendenti",
      COMMISSIONS: "Commesse"
    },
    INSERT: {
      PERSONAL_INFORMATION: "Inserisci le tue informazioni personali",
      PERSONAL_EXPERIENCE: "Inserisci le tue esperienze professionali",
      DESCRIBE_EXPERIENCE: "Descrivi la tua esperienza",
      WRITE_EXPERIENCE: "Scrivi la tua esperienza",
      SKILLS: "Inserisci le tue skills / competenze professionali",
      CERTIFICATIONS: "Inserisci qui certificazioni e attestati più significativi",
      EDUCATION: "Inserisci qui la tua esperienza formativa",
      FOREIGN_LANGUAGES: "Inserisci le tue certificazioni linguistiche",
      ADD_MASTERDATA: "Compila i tuoi dati anagrafici",
      ADD_EXPERIENCE: "Descrivi i tuoi progetti",
      ADD_SKILLS: "Aggiungi le tue competenze",
      ADD_EDUCATION: "Aggiungi la tua formazione",
      ADD_LANGUAGES: "Aggiungi le tue lingue",
      ADD_GENERALITY: "Inserisci le tue generalità",
      ADD_DOCUMENTS: "Inserisci i tuoi documenti",
      ADD_RESIDENCE: "Inserisci la tua residenza",
      UPLOAD_FILE: "Carica file",
      UPLOAD_DOCUMENT: "Carica documento",
      UPLOAD_DOCUMENTS: "Carica documenti",
      UPLOAD_CONTRACT: "Carica contratto",
      DOWNLOAD_DOCUMENTS: "Scarica documenti",
      DOWNLOAD_CONTRACT: "Scarica contratto",
      UPLOAD_FISCAL_CODE: "Carica codice fiscale",
      UPLOAD_PERMIT_DOCUMENT: "Carica permesso di soggiorno",
      INSERT_FIGURE: "Inserisci figura professionale",
      EDIT_FIGURE: "Inserisci figura professionale",
      DAY: "Giorno",
      ADD_REQUEST_LANGUAGES: "Aggiungi lingue",
      ADD_REQUEST_SKILLS: "Aggiungi skill",
      PARAMETERS_REQUEST: "Parametri richiesta",
      SELECT_CONTRACTS: "Seleziona contratto",
      ADD_IBAN: "Inserisci il tuo iban",
      UPLOAD_RECIPE: "Carica scontrino/fattura",
      VIEW_DOCUMENT: "Presa visione",
      VIEW_ONBOARDING_DOCUMENT: "Ti invitiamo a prendere visione e a scaricare alcuni documenti."
    },
    ANALYTICS: {
      AGE_OF_EMPLOYEES: "Età media dei dipendenti",
      WOMAN_EMPLOYEES: "Dipendenti donne",
      HIRED_RESIGN: "Dipendenti Assunti/Dimessi",
      TICKETS_CLOSED: "Ticket chiusi",
      LAST_MONTH: "Ultimo mese",
      LAST_YEAR: "Ultimo anno",
      NEW_TICKETS: "Nuovi ticket",
      OPEN_TICKET: "Ticket aperti",
      EMPLOYEES_ROLE: "Figure professionali dei dipendenti",
      CLIENT_SALES_VOLUME: "Fatturato clienti",
      CLIENT_SALE_VOLUME: "Fatturato cliente",
      COMPANY_SALE_VOLUME: "Fatturato aziendale",
      REVENUE_REPORT: "Andamento marginalità",
      EARNING: "Entrate",
      EXPENSE: "Uscite",
      SKILLS: "Mappatura skills",
      CANDIDATES_FOR_RECRUITERS: "Candidati inseriti per recruiter",
      SALES_COSTS: "Misurazione fatturato costi",
      EDGE_FOR_CLIENTS: "Fatturato, costo e margine per cliente",
      REQUESTED_JOBS: "Figure professionali più richieste per cliente",
      QUALIFICATIONS: "Titoli di studi più comuni fra i dipendenti",
      ELIGIBLE_CANDIDATE: "Candidati idonei",
      CANDIDATES_ROLE: "Figure professionali dei candidati",
      PROVIDER_AND_STRUTURAL_COSTS: "Costi fornitori e di struttura"
    },
    MODAL: {
      NOT_SKILL: "Non hai trovato la tua skill?",
      NOT_CERTIFICATE: "Non hai trovato la tua certificazione?",
      INSERT_HERE: "Inseriscila qui manualmente. Provvederemo noi a caricarla nel minor tempo possibile.",
      INSERT_SOURCE: "Inserisci una nuova fonte",
      EDIT_SOURCE: "Modifica fonte",
      ADD_REFERENT: "Inserisci un nuovo referente",
      EDIT_REFERENT: "Modifica Referente",
      INSERT_DOMAIN: "Inserisci un nuovo dominio",
      INSERT_TUTORIAL: "Aggiungi un nuovo tutorial",
      EDIT_TUTORIAL: "Modifica tutorial",
      INSERT_FIELD: "Inserisci un nuovo campo",
      INSERT_SHORTLINK: "Inserisci un nuovo short link",
      EDIT_DOMAIN: "Modifica dominio",
      EDIT_FIELD: "Modifica campo",
      NOT_SKILL_CANDIDATE: "Non hai trovato la skill?",
      NOT_CERTIFICATE_CANDIDATE: "Non hai trovato la certificazione?",
      SELECT_COLUMNS_TO_EXPORT: "Seleziona le colonne da esportare",
      SELECTABLE_COLUMNS: "Colonne selezionabili",
      CLEAN: "Annulla selezioni",
      COMPLETE_NAME: "Nome completo",
      NUMBER: "Matricola",
      FIGURE: "Figura",
      ROLE: "Ruolo",
      CITY: "Città",
      SEND_ONBOARDING: "Onboarding",
      BADGE_NUMBER: "Numero badge",
      BIRTHDAY: "Compleanno",
      EMAIL: "Email",
      FISCAL_CODE: "Codice fiscale",
      AVATAR: "Avatar",
      FIRSTNAME: "Nome",
      LASTNAME: "Cognome",
      WORKING_CITY: "Città di lavoro",
      SELECT_ALL_COLUMNS: "Seleziona tutte le colonne",
      CLICK_TO_SELECT: "Clicca per selezionare"
    },
    MANAGE_CONTRACTS_COSTS: "Gestione costi contratti",
    ALERT: {
      YES: "Si",
      NO: "No",
      INVALID_FORMAT: "Formato non valido, inserisci o pdf o jpg o jpeg",
      SUCCESS_UPLOAD_FILES: "File caricati con successo.",
      ERROR_UPLOAD_FILES: "Errore nel caricamento di uno o piu file.",
      ERROR_MAX_FILE_SIZE: "Il file non deve superare i 10MB.",
      ERROR_FILE_NOT_IMAGE_OR_PDF: "Attenzione, puoi caricare solo immagini o pdf.",
      ERROR_ENABLE_POPUP: "Per visualizzare il contenuto abilita le finestre a comparsa.",
      ERROR_EDIT_MAINTENANCE: "Errore nella modifica della manutenzione.",
      SUCCESS_EDIT_MAINTENANCE: "Manutenzione modificata con successo.",
      SUCCESS_DELETE_FILE: "File eliminato con successo.",
      BTN_SUCCESS: "OK",
      BTN_CLOSE: "Chiudi",
      BTN_CANCEL: "Annulla",
      BTN_OPEN: "Apri",
      BTN_RESTORE_EMPLOYEE: "Ripristina dipendente",
      NOT_FOUND_USER_STANDBY_COMMISSION: "Nessun dipendente fermo.",
      COMPLETED_TITLE: "Completato!",
      ALERT_TITLE: "Attenzione!",
      KEEP_ATTENTION: "Nota bene!",
      DELETED_TITLE: "Rimosso!",
      DELETED_TEXT: "Il contenuto è stato eliminato!",
      DELETED_USER_TEXT: "L'utente è stato eliminato!",
      ABORTED_TITLE: "Annullato!",
      ABORTED_TEXT: "L'eliminazione del contenuto è stata annullata, sei salvo :)",
      CANECEL_TEXT: "Non è stata effettuata nessuna azione, sei salvo :)",
      ABORTED_GENERATE_TEXT: "Annullata la generazione di un nuovo documento.",
      ABORTED_TITLE_EDIT: "La modifica del contenuto è stata annullata, sei salvo :)",
      USED_GROUP_TEXT: "Gruppo attualmente in uso, impossibile eliminarlo.",
      USED_SKILL_TEXT: "Skill attualmente in uso o attiva, impossibile eliminarla o disattivarla.",
      USED_CERTIFICATE_TEXT: "Certificazione attualmente in uso o attiva, impossibile eliminarla o disattivarla",
      CONFIRM_DELETE_TITLE: "Confermi l'operazione?",
      CONFIRM_DELETE_FILE: "Confermi di voler eliminare il file?",
      CONFIRM_DISABLE_TITLE: "Confermi di voler disabilitare l'elemento?",
      CONFIRM_CLOSE_BARGAINING: "Confermi di voler chiudere la contrattazione?",
      CONFIRM_RESTORE_TITLE: "Confermi di voler abilitare l'elemento?",
      CONFIRM_DELETE_TEXT: "Non potrai più ripristinare questo elemento! ",
      CONFIRM_STATUS_TEXT: "Con la seguente azione modificherai lo stato dell'elemento selezionato.",

      CONFIRM_CASHED_TEXT: "Stai impostando la fattura numero [NUMBER] come incassata",

      CONFIRM_ADD_COST_COLLABORATOR: "Sono presenti dei costi legati ai collaboratori, vuoi aggiungerli?",
      CONFIRM_REGENERATE_TEXT_MODAL: "L'operazione richiederà circa",
      CONFIRM_REGENERATE_TEXT_MODAL_SECOND: "minuti, sei sicuro di voler continuare?",
      CONFIRM_REGENERATE_TEXT_MODAL_SECOND_SINGULAR: "minuto, sei sicuro di voler continuare?",
      HAVE_SELECTED: "Hai selezionato",
      EMPLOYYE_WITH_NO_EMAIL: "I seguenti dipendenti non hanno un email:",
      EMPLOYEES: "dipendenti",
      CONFIRM_VIEW_PREVIEW_CONTRACT: "Prima di inviare il contratto assicurati di aver visualizzato l'anteprima del contratto. Il bottone è situato in alto a destra nella sezione proposta.",
      CONFIRM_RESEND_REQUEST_MASTERDATA: "Vuoi rinviare la richiesta dei dati anagrafici?.",
      CONFIRM_REGENERATE_TEXT: "Rigenerando il documento andrai a sovrascrivere il documento esistente.",
      SELECT_FORMAT_TEXT: "Seleziona il formato del file",
      PDF: "PDF",
      DOCX: "DOCX",
      CONFIRM_DELETE_THIS_OBJECT: " Stai eliminando ",
      CONFIRM_DELETE_THIS_COST: " Stai eliminando il costo del fornitore di ",
      CONFIRM_DELETE_THIS_NOTE: " Stai eliminando la nota: ",
      CONFIRM_DELETE_USER_TEXT: "L'eliminazione è permanente, non potrai più ripristinare questo utente.",
      CONFIRM_DELETE_BTN: "Rimuovi",
      CONFIRM_CASHED_BTN: "Imposta come incassata",
      CONFIRM_REGENERATE_BTN: "Si, rigenera",
      CONFIRM_SEND_EMAIL: "Si, invia email",
      CONFIRM_VIEWED_CONTRACT_BTN: "Ho visualizzato il contratto",
      CONFIRM_RESEND_MASTERDATA: "Si, rinvia la richiesta",
      CONFIRM_GENERATE_BTN: "Rigenera",
      CONFIRM_CANCEL_BTN: "Disabilita",
      CONFIRM_RESTORE_BTN: "Abilita",
      CONFIRM_UNLOCK: "Sblocca",
      CONFIRM_ASSOCIATE_BTN: "Associa",
      CONFIRM_DISSOCIATE_BTN: "Dissocia",
      NOTIFICATIONS_DENIED: "Per un'esperienza di utilizzo migliore, ti chiediamo di abilitare le notifiche",
      SUCCESS_GENERATE_CV: "Generazione del curriculum aziendale completata con successo.",
      ERROR_GENERATE_CV: "Errore nella generazione del curriculum aziendale.",
      SHIPPING_ADDRESS_NOT_COMPLETE: "L'indirizzo di spedizione inserito non è completo. Gli altri dati verranno processati comunque.",
      BILLING_ADDRESS_NOT_COMPLETE: "L'indirizzo di fatturazione inserito non è completo. Gli altri dati verranno processati comunque.",
      RESIDENCE_ADDRESS_NOT_COMPLETE: "L'indirizzo di residenza inserito non è completo. Gli altri dati verranno processati comunque.",
      MASTERDATA_NOT_COMPLETE: "Errore nella sezione Anagrafica",
      ADDRESSES_NOT_COMPLETE: "Errore nella sezione Indirizzi",
      INFORMATIONS_NOT_COMPLETE: "Errore nella sezione Informazioni",
      CONTRACT_NOT_COMPLETE: "Errore nella sezione Contratto",
      ID_DOCUMENT_NOT_COMPLETE: "Errore nella sezione Documento d'identità",
      ERROR_EXPERIENCES_LIST_EMPTY: "Inserisci almeno una esperienza professionale.",
      ERROR_EXPERIENCES_FIELDS_EMPTY: "Alcune esperienze professionali non sono compilate correttamente, per favore verifica e riprova.",
      ERROR_LANGUAGES_FIELDS_EMPTY: "Alcune lingue non sono compilate correttamente, per favore verifica e riprova.",
      ERROR_SKILLS_LIST_EMPTY: "Inserisci almeno una skill.",
      ERROR_SKILLS_FIELDS_EMPTY: "Alcune skill non sono compilate correttamente, per favore verifica e riprova.",
      ERROR_EXPERIENCES_INSERT: "Errore nell'inserimento dell'esperienze.",
      ERROR_EDUCATION_INSERT: "Errore nell'inserimento del titolo di studi.",
      ERROR_EDUCATION_EDIT: "Errore nella modifica del titolo di studi.",
      ERROR_EDUCATION_REMOVE: "Errore nell'eliminazione del titolo di studi, per favore verifica e riprova.",
      ERROR_EXPERIENCES_FIELDS: "Alcuni dati non sono validi.",
      ERROR_MASTER_DATA_INSERT: "Errore nell'inserimento dell'anagrafica",
      ERROR_FILL_ALL_DATES: "Valorizzare entrambe le date. (Data inizio e Data fine)",
      ERROR_DONWLOAD_FILE: "Errore nel download, riprova o contatta lo staff.",
      MASTERDATA_SENDED: "Richiesta dei dati anagrafici inviata con successo.",
      MASTERDATA_SENDED_ERROR: "Errore nella richiesta dei dati anagrafici.",
      SIGN_CONTRACT_REQUESTED_SEND: "Inviato con successo il contratto da firmare.",
      WARNING_CHANGING_CONTRACT_LEVEL_DOWN: "Livello di contratto diminuito automaticamente.",
      WARNING_CHANGING_CONTRACT_LEVEL_UP: "Livello di contratto aumentato automaticamente.",
      ERROR_UPLOAD_CONTRACT: "Errore nel caricamento del contratto.",
      SUCCESS_UPLOAD_CONTRACT: "Contratto caricato correttamente.",
      SUCCESS_UPLOAD_SOURCE: "Fonte aggiunta correttamente.",
      ERROR_UPLOAD_SOURCE: "Errore nell'aggiunta della fonte.",
      SUCCESS_EDIT_SOURCE: "Fonte modificata correttamente.",
      ERROR_EDIT_SOURCE: "Errore nella modifica della fonte.",
      ERROR_DELETE_SOURCE: "Errore nella cancellazione della fonte.",
      SUCCESS_DELETE_SOURCE: "Fonte eliminata con successo.",
      SUCCESS_UPLOAD_FIGURE: "Figura Professionale aggiunta correttamente.",
      ERROR_UPLOAD_FIGURE: "Errore nel caricamento della figura professionale.",
      SUCCESS_EDIT_FIGURE: "Figura Professionale modificata con successo.",
      ERROR_EDIT_FIGURE: "Errore nella modifica della figura professionale.",
      SUCCESS_UPLOAD_DEPARTMENT: "Dipartimento caricato correttamente.",
      ERROR_UPLOAD_DEPARTMENT: "Errore nella modifica del dipartimento.",
      SUCCESS_EDIT_DEPARTMENT: "Dipartimento modificato correttamente.",
      ERROR_EDIT_DEPARTMENT: "Errore nel caricamento del dipartimento.",
      ERROR_DELETE_DEPARTMENT: "Errore nell'eliminazione del dipartimento.",
      SUCCESS_EDIT_EDUCATION: "Titolo di studio modificato correttamente.",
      SUCCESS_UPLOAD_EDUCATION: "Titolo di studio aggiunto correttamente.",
      USED_FIGURE_TEXT: "La figura professionale selezionata è attualmente in uso da uno o più utenti. Impossibile eliminarla.",
      USED_DEPARTMENT_TEXT: "Il dipartimento selezionato è attualmente in uso da uno o più utenti. Impossibile eliminarlo.",
      USED_EDUCATION_TEXT: "Il titolo di studio selezionato è attualmente in uso da uno o più utenti. Impossibile eliminarlo.",
      USED_ROLE_TEXT: "Il ruolo selezionato è attualmente in uso da uno o più utenti. Impossibile eliminarlo",
      NOTHING_TO_UPDATE: "Niente da aggiornare",
      USER_UPDATE_CORRECT: "Utente aggiornato correttamente",
      USER_UPDATE_ERROR: "Errore nell'aggiornamento dell'utente",
      SKILL_TO_APPORVE: "La skill sarà disponibile sul tuo profilo non appena approvata",
      CERTIFCATE_TO_APPORVE: "La certificazione sarà disponibile sul tuo profilo non appena approvata",
      SOME_DATA_IS_INVALID: "Alcuni dati non sono validi, verifica e riprova",
      CONTRACT_DATA_IS_INVALID: "Alcuni dati del contratto non sono validi",
      SUCCESS_EDIT_EDUCATION_SUBJECT: "Facoltà modificata correttamente",
      SUCCESS_UPLOAD_EDUCATION_SUBJECT: "Facoltà aggiunta correttamente",
      ERROR_EDUCATION_SUBJECT_EDIT: "Errore nella modifica della facoltà",
      ERROR_EDUCATION_SUBJECT_REMOVE: "Errore nell'eliminazione della facoltà, per favore verifica e riprova",
      ERROR_EDUCATION_SUBJECT_UPLOAD: "Errore nella aggiunta della facoltà",
      SUCCESS_EDIT_ROLE: "Ruolo modificato correttamente",
      SUCCESS_UPLOAD_ROLE: "Ruolo aggiunto correttamente",
      ERROR_ROLE_EDIT: "Errore nella modifica del ruolo",
      ERROR_ROLE_REMOVE: "Errore nell'eliminazione del ruolo, per favore verifica e riprova",
      ERROR_ROLE_UPLOAD: "Errore nella aggiunta del ruolo",
      ERROR_REMOVE_MAINTENANCE: "Errore nella rimozione della manutenzione.",
      SUCCESS_UPLOAD_CERTIFICATE: "Certificazione caricata correttamente",
      ERROR_UPLOAD_CERTIFICATE: "Errore nel caricamento della nuova certificazione, per favore riprova più tardi",
      SUCCESS_EDIT_CERTIFICATE: "Certificazione modificata correttamente",
      ERROR_EDIT_CERTIFICATE: "Errore nella modifica della  certificazione, per favore riprova più tardi",
      ERROR_REMOVE_CERTIFICATE: "Errore nell'eliminazione della certificazione, per favore riprova più tardi",
      SUCCESS_APPROVE_CERTIFICATE: "Certificazione approvata correttamente",
      SUCCESS_REJECT_CERTIFICATE: "Certificazione rifiutata correttamente",
      ERROR_UPLOAD_CAPABILITY: "Errore nell'aggiunta del diritto utente.",
      ERROR_EDIT_CAPABILITY: "Errore nella modifica del diritto utente.",
      SUCCESS_EDIT_CAPABILITY: "Diritto utente modificato con successo.",
      SUCCESS_UPLOAD_CAPABILITY: "Diritto utente creato con successo.",
      SUCCESS_CAPABILITY_ASSIGN: "Diritti utente aggiornati correttamente.",
      ERROR_CAPABILITY_ASSIGN: "Errore nell'aggiornamento dei diritti utente.",
      CONTRACT_COSTS_UPDATED: "Costi dei contratti aggiornati con successo.",
      CONTRACT_COSTS_NOT_UPDATED: "Costi dei contratti non aggiornati.",
      SUCCESS_JOB_POSITIONS_UPLOAD: "La posizione è stata creata correttamente.",
      ERROR_JOB_POSITIONS_UPLOAD: "Errore nella creazione della posizione.",
      SUCCESS_JOB_POSITIONS_EDIT: "La posizione è stata modificata correttamente.",
      ERROR_JOB_POSITIONS_EDIT: "'Errore nella modifica della posizione.",
      ERROR_UPDATE_USER: "Errore nell'aggiornamento dell'utente.",
      SUCCESS_UPDATE_USER: "Utente aggiornato correttamente.",
      SUCCESS_UPDATE_USER_PASSWORD: "Password modificata correttamente.",
      ERROR_UPDATE_USER_PASSWORD: "Errore nella modifica della password.",
      RESIDENCE_PERMIT_UPLOAD_ERROR: "Errore nell'upload del permesso di soggiorno.",
      FISCAL_CODE_UPLOAD_ERROR: "Errore nel caricamento del codice fiscale.",
      ID_DOCUMENT_UPLOAD_ERROR: "Errore nel caricamento del documento di identità.",
      RESIGNATION_FILE_UPLOAD_ERROR: "Errore nell'upload del file delle dimissioni.",
      AVATAR_UPLOAD_ERROR: "Errore nell'aggiornamento dell'avatar.",
      UNAUTHORIZED: "Non sei autorizzato ad eseguire questa operazione.",
      AVATAR_UPLOAD_INFO: "Solo file JPG, JPEG o PNG di massimo 10MB. Le dimensioni consigliate sono 600x600.",
      EXPIRE_DATE_ERROR: "Data scadenza documento non valida.",
      BIRTH_DATE_ERROR: "Data di nascita non valida.",
      SUCCESS_USER_DATA_INSERT: "Dati inseriti correttamente.",
      ERROR_USER_DATA_INSER: "Errore nell'inserimento dei dati, riprova fra qualche minuto. Se l'errore persiste contatta lo staff.",
      SUCCESS_UPLOAD_USER: "L'utente è stato creato correttamente.",
      ERROR_UPLOAD_USER: "Errore nella creazione del nuovo utente.",
      SUCCESS_EDIT_SKILL: "Skill modificata correttamente.",
      SUCCESS_UPLOAD_SKILL: "Skill aggiunta correttamente.",
      ERROR_UPLOAD_SKILL: "Errore nella creazione della skill.",
      ERROR_EDIT_SKILL: "Errore nella modifica della skill.",
      ERROR_REMOVE_SKILL: "Errore nell'eliminazione della skill.",
      ERROR_DISABLE_BARGAINING: "Errore nella disabilitazione della contrattazione.",
      ERROR_RESTORE_BARGAINING: "Errore nell'abilitazione della contrattazione.",
      SUCCESS_DISABLE_BARGAINING: "Contrattazione disabilitata con successo.",
      SUCCESS_RESTORE_BARGAINING: "Contrattazione abilitata con successo.",
      SUCCESS_APPROVE_SKILL: "Skill approvata con successo.",
      SUCCESS_REJECT_SKILL: "Skill rifiutata con successo.",
      SUCCESS_EDIT_GROUP: "Gruppo modificato correttamente.",
      ERROR_DELETE_GROUP: "Errore nell'eliminazione del gruppo.",
      SUCCESS_DELETE_GROUP: "Il gruppo è stato rimosso correttamente.",
      SUCCESS_UPLOAD_GROUP: "Gruppo aggiunto correttamente.",
      ERROR_UPLOAD_GROUP: "Errore nella creazione del gruppo.",
      ERROR_EDIT_GROUP: "Errore nella modifica del gruppo.",
      ERROR_REMOVE_GROUP: "Errore nell'eliminazione del gruppo.",
      SUCCESS_ACTIVATED_GROUP: "Gruppo attivato con successo.",
      SUCCESS_DISABLED_GROUP: "Gruppo disattivato con successo.",
      EMPTY_FIELD_FORM: "Alcuni campi obbligatori sono vuoti o non sono validi.",
      SUCCESS_UPLOAD_CITY: "Città creata con successo",
      ERROR_UPLOAD_CITY: "Errore nella creazione della città",
      SUCCESS_EDIT_CITY: "Città modificata con successo",
      ERROR_EDIT_CITY: "Errore nella modifica della città",
      SUCCESS_UPLOAD_TYPE_ABSENCE: "Tipo di assenza creata con successo",
      ERROR_UPLOAD_TYPE_ABSENCE: "Errore nella creazione del tipo di assenza",
      SUCCESS_EDIT_TYPE_ABSENCE: "Tipo di assenza modificata con successo",
      ERROR_EDIT_TYPE_ABSENCE: "Errore nella modifica del tipo di assenza",
      ERROR_TYPE_ABSENCE_USED: "Tipo di assenza in uso da uno o più utenti, impossibile eliminarla!",
      ERROR_DELETE_TYPE_ABSENCE: "Errore nell'eliminazione del tipo di assenza",
      SUCCESS_EDIT_COMMUNICATION_CATEGORY: "Categoria modificata correttamente",
      SUCCESS_UPLOAD_COMMUNICATION_CATEGORY: "Categoria aggiunta correttamente",
      SUCCESS_UPLOAD_TUTORIAL: "Tutorial aggiunto correttamente",
      SUCCESS_EDIT_TUTORIAL: "Tutorial modificato correttamente",
      ERROR_COMMUNICATION_CATEGORY_EDIT: "Errore nella modifica della categoria",
      ERROR_COMMUNICATION_CATEGORY_REMOVE: "Errore nell'eliminazione della categoria, per favore verifica e riprova",
      ERROR_COMMUNICATION_CATEGORY_UPLOAD: "Errore nella aggiunta della categoria",
      ERROR_TUTORIAL_UPLOAD: "Errore nella aggiunta del tutorial",
      ERROR_TUTORIAL_EDIT: "Errore nella modifica del tutorial",
      ERROR_COMMUNICATION_CATEGORY_DELETE: "Errore nell'eliminazione della categoria",
      ERROR_TUTORIAL_DELETE: "Errore nell'eliminazione del tutorial",
      ERROR_DEAL_DELETE: "Errore nell'eliminazione dell'offerta",
      ERROR_EMPTY_FIELDS: "Alcuni campi obbligatori sono vuoti.",
      ERROR_TRANCHE_TASK: "I campi N.Tranche o Importo Tranche non validi.",
      ERROR_TIME_MATERIAL_EFFORT_OR_DAILY_RATE: "I campi N.giornate o Tariffa giornaliera non sono validi.",
      ERROR_TASK_SINGLE_TRANCHE_IMPORT: "I campi importo mensile o importo tranche dipendente non sono validi.",
      SUCCES_DELETE_FIGURE: "Figura eliminata correttamente",
      ERROR_SEND_COMMUNICATION: "Errore nell'invio della comunicazione",
      SUCCESS_SEND_COMMUNICATION: "Comunicazione creata con successo",
      SUCCESS_UPDATE_COMMUNICATION: "Comunicazione modificata con successo",
      ERROR_UPDATE_COMMUNICATION: "Errore nella modifica della comunicazione",
      ERROR_REMOVE_COMMUNICATION: "Errore nell'eliminazione della comunicazione",
      SUCCESS_SEND_HOLIDAY: "Ferie richiesta con successo",
      ERROR_SEND_HOLIDAY: "Errore nella richiesta delle ferie",
      ERROR_DATE_REQUESTED: "Imposta un range di date corretto",
      ERROR_URL_CLEAR_CACHE_EMPTY: "Inserisci l' url",
      SUCCESS_EDIT_ROUND_DATE: "Data round precedente modificata con successo",
      ERROR_EDIT_ROUND_DATE: "Errore nella modifica della data round precedente",
      SUCCESS_SEND_PERMISSIONS: "Permesso richiesto con successo",
      ERROR_SEND_PERMISSIONS: "Errore nella richiesta del permesso",
      SUCCESS_SEND_SICKNESS: "Malattia richiesta con successo",
      ERROR_SEND_SICKNESS: "Errore nella richiesta della malattia",
      SUCCESS_APPROVED_ABSENCE: "Richiesta assenza approvata con successo",
      SUCCESS_REJECT_ABSENCE: "Richiesta assenza rifiutata con successo",
      ERROR_EDIT_ABSENCE: "Errore nella modifica dell'assenza",
      SUCCESS_CANCEL_ABSENCE: "Richiesta assenza annullata con successo",
      ERROR_NOTE_REQUIRE: "Inserisci la nota",
      INSERT_TYPE_HOLIDAY: "Inserisci il tipo di ferie",
      ERROR_FILE_REQUIRE: "Inserisci un file",
      SUCCESS_SEND_REFUND: "Rimborso richiesto con successo",
      ERROR_SEND_REFUND: "Errore nella richiesta del rimborso",
      SUCCESS_APPROVED_REFUND: "Richiesta rimborso approvata con successo",
      SUCCESS_REJECT_REFUND: "Richiesta rimborso rifiutata con successo",
      ERROR_EDIT_REFUND: "Errore nella modifica dell'rimborso",
      SUCCESS_CANCEL_REFUND: "Richiesta rimborso eliminata con successo",
      INSERT_CATEGORY: "Inserisci una categoria",
      SUCCESS_SEND_WORKDAY_REPORT: "Rapporto mensile inviato con successo",
      ERROR_SEND_WORKDAY_REPORT: "Errore nell'invio del rapporto mensile",
      SUCCESS_SAVE_WORKDAY_REPORT: "Rapporto mensile salvato con successo",
      ERROR_SAVE_WORKDAY_REPORT: "Errore nell'salvataggio del rapporto mensile",
      SUCCESS_UPDATE_WORKDAY_REPORT: "Rapporto mensile modificato con successo",
      ERROR_UPDATE_WORKDAY_REPORT: "Errore nella modifica del rapporto mensile",
      MAX_WORK_HOURS: "Impossibile inserire più di 12 ore lavorative.",
      MIN_WORK_HOURS: "Devi inserire almeno 8 ore lavorative incluse le ore di permesso.",
      SUCCESS_APPROVED_WORKDAY_REPORT: "Rapporto mensile approvato con successo.",
      ERROR_APPROVED_WORKDAY_REPORT: "Errore nell'approvazione del rapporto mensile",
      SUCCESS_EDIT_WORKDAY_REPORT: "Rapporto mensile modificato con successo.",
      ERROR_EDIT_WORKDAY_REPORT: "Errore nella modifica del rapporto mensile",
      SUCCESS_REJECT_WORKDAY_REPORT: "Rapporto mensile rifiutato con successo",
      ERROR_REJECT_WORKDAY_REPORT: "Errore nella modifica del rapporto mensile",
      CONFIRM_UNLOCK_WORKDAY_REPORT: "Stai sbloccando il rapporto mensile di ",
      CONFIRM_UNLOCK_WORKDAY_REPORT_CONTINUE: " Gli/le permetterai di poterlo rinviare, sei sicuro di voler continuare? ",
      SUCCESS_UNLOCK_WORKDAY_REPORT: "Rapporto mensile sbloccato con successo",
      CONFIRM_BTN: "Conferma",
      SELECT_PRIMARY_SKILL: "Seleziona una skill come principale",
      SELECT_PRIMARY_EDUCATION: "Seleziona un esperienza formativa in evidenza",
      ERROR_UPLOAD_CURRICULUM: "Errore nell'upload del curriculum",
      CANDIDATE_UPDATED_SUCCESSFULLY: "Candidato aggiornato con successo",
      CANDIDATE_UPDATED_ERROR: "Errore nell'aggiornamento del candidato",
      CANDIDATE_ADDED_SUCCESSFULLY: "Candidato aggiunto con successo",
      CANDIDATE_DELETE_SUCCESSFULLY: "Candidato eliminato con successo",
      CANDIDATE_DELETE_ERROR: "Errore nell'eliminazione del candidato",
      CANDIDATE_ADDED_ERROR: "Errore nell'aggiunta del candidato",
      // -- messaggi creazione referente cliente
      SUCCESS_ADD_CUSTOMER_REFERENT: "Referente aggiunto con successo.",
      ERROR_ADD_CUSTOMER_REFERENT: "Errore nella creazione del referente.",
      // -- messaggi modifica referente cliente
      SUCCESS_EDIT_CUSTOMER_REFERENT: "Referente modificato correttamente.",
      ERROR_EDIT_CUSTOMER_REFERENT: "Errore nella modifica del referente.",
      // -- messaggi eliminazione referente cliente
      SUCCESS_DELETE_CUSTOMER_REFERENT: "Referente eliminato correttamente.",
      ERROR_DELETE_CUSTOMER_REFERENT: "Errore nell'eliminazione del referente.",
      // -- messaggi creazione sede cliente
      SUCCESS_ADD_CUSTOMER_SITE: "Sede aggiunta con successo.",
      ERROR_ADD_CUSTOMER_SITE: "Errore nella creazione della sede.",
      // -- messaggi modifica sede cliente
      SUCCESS_UPDATE_CUSTOMER_SITE: "Sede modificato correttamente.",
      ERROR_UPDATE_CUSTOMER_SITE: "Errore nella modifica della sede.",
      // -- messaggi eliminazione sede cliente
      SUCCESS_DELETE_CUSTOMER_SITE: "Eliminazione della sede avvenuta con successo.",
      ERROR_DELETE_CUSTOMER_SITE: "Errore nella rimozione della sede.",
      // -- messaggi creazione cliente
      SUCCESS_ADD_CUSTOMER: "Cliente aggiunto con successo.",
      ERROR_ADD_CUSTOMER: "Errore nella creazione del cliente.",
      // -- messaggi modifica cliente
      SUCCESS_EDIT_CLIENT: "Cliente modificato correttamente.",
      ERROR_EDIT_CLIENT: "Errore nella modifica del cliente.",
      // -- messaggi eliminazione cliente
      SUCCESS_DELETE_CUSTOMER: "Cliente eliminato correttamente.",
      SUCCESS_DELETE_FIELD: "Campo eliminato correttamente.",
      SUCCESS_DELETE_SHORTLINK: "Short link eliminato correttamente.",
      ERROR_DELETE_CUSTOMER: "Errore nell'eliminazione del cliente.",
      ERROR_DELETE_SHORTLINK: "Errore nell'eliminazione dello short link.",
      ERROR_DELETE_FIELD: "Errore nell'eliminazione del cliente.",
      ERROR_UPDATE_CLIENT_LOGO: "Errore nella modifica del logo del cliente.",
      CANDATE_UPDATED_ERROR: "Errore nell'aggiornamento del candidato",
      INSERT_MAX_THREE_REQUESTED_SKILL: "Puoi selezionare al massimo tre skill come obbligatorie",
      SUCCESS_CREATE_CUSTOMER_REQUEST: "Richiesta creata con successo.",
      ERROR_CREATE_CUSTOMER_REQUEST: "Errore nella creazione della richiesta.",
      SUCCESS_EDIT_CUSTOMER_REQUEST: "Richiesta modificata con successo. Le job position collegate a questa richiesta sono state cancellate, le eventuali candidature sono state scollegate.",
      ERROR_EDIT_CUSTOMER_REQUEST: "Errore nella modifica della richiesta.",
      ERROR_DELETE_REQUEST: "Errore nell'eliminazione della richiesta.",
      SUCCESS_CLOSE_REQUEST: "Richiesta chiusa con successo.",
      ERROR_CLOSE_REQUEST: "Errore nella chiusura della richiesta.",
      SUCCESS_OPEN_REQUEST: "Richiesta riaperta con successo.",
      ERROR_OPEN_REQUEST: "Errore nella riapertura della richiesta.",
      ERROR_INSERT_LANGUAGES_DETAILS: "Inserisci il livello parlato o scritto della lingua selezionata.",
      SUCCESS_INSERT_SUITABLE_CANDIDATE: "Candidato inserito tra gli idonei con successo.",
      SUCCESS_INSERT_SUITABLE_EMPLOYEE: "Dipendente inserito tra gli idonei con successo.",
      SUCCESS_INSERT_SUITABLE_EX_EMPLOYEE: "Ex Dipendente inserito tra gli idonei con successo.",
      ERROR_INSERT_SUITABLE_EMPLOYEE: "Errore nell'inserimento del dipendente tra gli idonei.",
      ERROR_INSERT_SUITABLE_CANDIDATE: "Errore nell'inserimento del dipendente tra gli idonei.",
      ERROR_INSERT_SUITABLE_EX_EMPLOYEE: "Errore nell'inserimento dell'ex dipendente tra gli idonei.",
      SUCCESS_INSERT_STEP: "Aggiornato con successo l'iter del candidato.",
      ERROR_INSERT_STEP: "Errore nell'aggiornamento  dell'iter del candidato.",
      CONTROL_SECOND_INTERVIEW_DATE: "La data del secondo colloquio non può essere inferiore alla data del primo colloquio",
      CONTROL_PERCENTAGE_PARAMETERS: "La somma totale dei parameteri deve essere uguale a 100",
      SUCCESS_EDIT_DOCUMENTS_CATEGORY: "Categoria modificata correttamente",
      SUCCESS_ADD_DOCUMENTS_CATEGORY: "Categoria aggiunta correttamente",
      ERROR_ADD_DOCUMENTS_CATEGORY: "Errore nell'aggiunta della categoria",
      ERROR_DOCUMENTS_CATEGORY_EDIT: "Errore nella modifica della categoria",
      ERROR_DOCUMENTS_CATEGORY_REMOVE: "Errore nell'eliminazione della categoria, per favore verifica e riprova",
      ERROR_DOCUMENTS_CATEGORY_UPLOAD: "Errore nella aggiunta della categoria,",
      SUCCESS_SEND_DOCUMENT: "Documento inserito correttamente",
      ERROR_SEND_DOCUMENT: "Errore nell'invio del documento,",
      SUCCESS_UPLOAD_FILE_DOCUMENT: "Documento caricato correttamente",
      ERROR_UPLOAD_FILE_DOCUMENT: "Errore nel upload del documento",
      SUCCESS_CREATE_FILE_DOCUMENT: "File creato correttamente",
      ERROR_CREATE_FILE_DOCUMENT: "Errore nella creazione del file",
      SUCCESS_UPDATE_FILE_DOCUMENT: "File modificato correttamente",
      ERROR_UPDATE_FILE_DOCUMENT: "Errore nella modifica del file del documento",
      ERROR_DOCUMENT_REMOVE: "Errore nell'eliminazione del documento, per favore verifica e riprova",
      SUCCESS_APPROVED_DOCUMENT: "Documento approvato con successo",
      SUCCESS_REJECT_DOCUMENT: "Documento rifiutato con successo",
      ERROR_EDIT_DOCUMENT: "Errore nella modifica del documento",
      SUCCESS_READ_DOCUMENT: "Documento visionato con successo",
      ERROR_READ_DOCUMENT: "Errore nella visione del documento",
      ERROR_DATE_INSERT: "La data di inizio è maggiore rispetto alla data di fine",
      EXPIRE_DATE_MINIMUM: "La data di scadenza non può essere antecedente a domani.",
      EXPIRE_DATE_GREATER_THAN_SEND_DATE: "La data di scadenza non può essere antecedente alla data d'invio",
      ERROR_INSERT_FILE: "Inserisci un file",
      ERROR_INSERT_TEXT: "Inserire del testo",
      ERROR_INSERT_USER: "Inserisci almeno un dipendente o un gruppo.",
      SUCCESS_RELOAD_ECONOMIC: "Calcoli economici rigenerati correttamente",
      ERROR_RELOAD_ECONOMIC: "Errore nella rigenerazione dei calcoli economici",
      ERROR_RELOAD_MISS_FILED: "Errore, mancano alcuni dati per rigenerare il calcolo economico.",
      CONFIRM_PROCESS_TIME_TEXT: "Attenzione, i documenti saranno processati entro le ",
      OF_THE: " del ",
      NEW_CHAT_OPENED: "Hai una nuova chat",
      SUCCESS_SEND_BARGAINING: "Contrattazione creata con successo.",
      ERROR_SEND_BARGAINING: "Errore nella creazione della contrattazione.",
      SUCCESS_UPDATE_BARGAINING: "Contrattazione modificata con successo.",
      ERROR_UPDATE_BARGAINING: "Errore nella modifica della contrattazione.",
      CONTROL_CONTRACT_DATE: "La data di fine contratto non può essere inferiore alla data di inizio contratto, più il periodo di prova.",
      SUCCESS_REQUEST_CONTRACT_DOCUMENT: "Richiesta contratto da firmare inviata con successo.",
      ERROR_REQUEST_CONTRACT_DOCUMENT: "Errore nella richiesta del contratto da firmare.",
      ERROR_APPROVED_DOCUMENT: "Errore nell'approvazione del documento.",
      ERROR_REJECT_DOCUMENT: "Errore nella declinazione del Documento",
      ERROR_CANDIDATE_IS_ALREADY_BARGAINING: "Il candidato ha già una contrattazione avviata.",
      NOT_FOUND_USER: "Nessun utente trovato.",
      NOT_FOUND_CANDIDATE: "Nessun candidato trovato.",
      ERROR_DUPLICATE_SKILL: "Hai inserito due skill uguali, rimuovi la skill duplicata.",
      ERROR_REMOVE_BARGAINING: "Errore nella rimozione della contrattazione.",
      ERROR_REMOVE_ASSET: "Errore nella rimozione dell'asset.",
      ERROR_ASSET_ASSIGNED: "L'asset selezionato è al momento assegnato ad un dipendente, per rimuoverlo devi prima dissociarlo",
      ERROR_ABSCENCE_ALREADY_REQUESTED: "Hai già un'assenza per lo stesso giorno!",
      ERROR_NOT_FOUND_BARGAINING: "Nessuna contrattazione trovata.",
      ERROR_NOT_FOUND_REQUEST: "Nessuna richiesta trovata.",
      ERROR_NOT_FOUND_PROPOSED_CANDIDATE: "Nessun candidato proposto.",
      ERROR_PROOF_NOT_FOUND: "Inserisci prova di validità",
      ERROR_DUPLICATE_CERTIFICATIONS: "Hai inserito due certificazioni uguali, rimuovi la certificazione duplicata.",
      ERROR_DUPLICATE_LANGUAGES: "Hai inserito due lingue uguali, rimuovi la lingua duplicata.",
      SUCCESS_NOTIFICATION_SET_READ: "Notifiche impostate come lette con successo.",
      ERROR_NOTIFICATION_SET_READ: "Errore nell'impostazione delle notifiche come lette.",
      SUCCESS_MULTIPLE_EMAIL: "Email di benvenuto inviate con successo.",
      ERROR_MULTIPLE_EMAIL: "Errore nell'invio delle email di benvenuto.",
      ERROR_NOT_IDENTICAL_PASSWORD: "Le password non coincidono.",
      SUCCESS_CREATE_PASSWORD: "Password creata con successo.",
      SUCCESS_EDIT_PASSWORD: "Password modificata con successo.",
      ERROR_CREATE_PASSWORD: "Errore nella creazione della password.",
      MINIMUM_CHARACTERS_PASSWORD_ERROR: "La password deve essere lunga almeno sei caratteri.",
      SUCCESS_UPDATE_RESIDUAL_ABSENCES: "Lista assenze residue aggiornata con successo.",
      ERROR_UPDATE_RESIDUAL_ABSENCES: "Errore nell'aggiornamento delle assenze residue.",
      SUCCESS_UPLOAD_FILE: "File caricato con successo.",
      ERROR_UPLOAD_FILE: "Errore nel caricamento del file",
      ERROR_FISCAL_CODE: "Codice fiscale non trovato",
      USER_ALREADY_IN_BARGAINING: "Il candidato ha già una contrattazione avviata.",
      INSERT_ROLES: "Inserisci almeno un ruolo.",
      INSERT_DESCRIPTION_OR_FILE: "Inserisci la descrizione o i file.",
      INSERT_DESCRIPTION: "Inserisci la descrizione",
      VIDEOS_REQUIRED: "Inserisci tutti e 3 i formati del tutorial.",
      ERROR_USER_DATA_INSERT: "Errore nell'inserimento dei dati, riprova fra qualche minuto. Se l'errore persiste contatta lo staff.",
      SUCCESS_CLOSE_BARGAINING: "Contrattazione chiusa con successo.",
      ERROR_CLOSE_BARGAINING: "Errore nella chiusura della contrattazione.",
      ERROR_CREATE_CAPABILITY: "Errore nella creazione del diritto utente",
      SUCCESS_DELETE_DOMAIN: "Dominio eliminato correttamente.",
      ERROR_DELETE_DOMAIN: "Errore nell'eliminazione del dominio.",
      SUCCESS_UPLOAD_DOMAIN: "Dominio aggiunto correttamente.",
      SUCCESS_UPLOAD_FIELD: "Campo aggiunto correttamente.",
      SUCCESS_UPLOAD_SHORTLINK: "Short link aggiunto correttamente.",
      ERROR_UPLOAD_DOMAIN: "Errore nell'aggiunta del dominio.",
      ERROR_UPLOAD_FIELD: "Errore nell'aggiunta del campo.",
      ERROR_UPLOAD_SHORTLINK: "Errore nell'aggiunta dello short link.",
      SUCCESS_EDIT_DOMAIN: "Dominio modificato correttamente.",
      SUCCESS_EDIT_FIELD: "Campo modificato correttamente",
      ERROR_EDIT_DOMAIN: "Errore nella modifica del dominio.",
      ERROR_EDIT_FIELD: "Errore nella modifica del campo",
      YES_BUTTON: "SI",
      NO_BUTTON: "No",
      YES_CLOSE: "Si, chiudi!",
      YES_REOPEN: "Si, riapri!",
      WOULD_YOU_ADD_ATTACCHMENTS: "Vuoi caricare degli allegati al contratto?",
      PAYROLL_FILES_LENGTH_ERROR: "Il numero di file inseriti non corrisponde al totale dei dipendenti.",
      PAYROLL_LEFT_USER_DESCRIPTION: "Non è stata inserita la busta paga per i seguenti dipendenti: ",
      PAYROLL_FISCAL_CODE_NOT_MATCH: "Nessun dipendente trovato per i seguenti codici fiscali: ",
      EMPLOYEE_RESIGNATION_REVOKED_SUCCESSFULLY: "Dimissioni/licenziamento del dipendente revocate con successo.",
      EMPLOYEE_RESIGNATION_REVOKED_ERROR: "Errore nel revocare le dimissioni/licenziamento del dipendente",
      PAYROLL_FISCAL_CODE_DUPLICATE: "Attenzione hai inserito dei duplicati per i seguenti codici fiscali:",
      SUCCESS_INSERT_NOTE: "Nota inserita con successo.",
      SUCCESS_EDIT_NOTE: "Nota modificata con successo.",
      ERROR_INSERT_NOTE: "Errore nell'inserimento della nota.",
      ERROR_EDIT_NOTE: "Errore nella modifica della nota",
      SUCCESS_DELETE_NOTE: "Nota eliminata con successo.",
      ERROR_DELETE_NOTE: "Errore nell'eliminazione della nota.",
      ERROR_MIN_NET_MONTHLY_12_STAGE: "Il netto mensile deve essere almeno di 800€",
      ERROR_MIN_TOTAL_DAILY_VAT_NUMBER: "Il costo giornaliero è errato.",
      ERROR_FILE_SIZE: "Il file supera i 10MB, utilizza il link sotto il campo Curriculum Vitae per comprimerlo.",
      ERROR_FILE_SIZE_ONBOARDING_AVATAR: "Il file supera i 10MB.",
      invalid_signature: "Sessione scaduta, effettua l'accesso.",
      ERROR_SKILL_ALREADY_EXIST: "La skill è gia presente nella tua lista.",
      ERROR_SKILL_ALREADY_EXIST_IN_DATABASE: "La skill è gia presente nei nostri database.",
      SAVE_FIRST_YOUR_PROPOSED_SKILL: "Premi prima il tasto salva per salvare le skill suggerite.",
      ERROR_CERTIFICATION_ALREADY_EXIST_IN_DATABASE: "La certificazione è gia presente nei nostri database",
      ERROR_CERTIFICATION_ALREADY_EXIST: "La certificazione è gia presente nella tua lista",
      SUCCESS_CREATE_CATEGORY_EXTRA_HOURS: "Categoria creata con successo.",
      ERROR_CREATE_CATEGORY_EXTRA_HOURS: "Errore nella creazione della categoria.",
      SUCCESS_UPDATE_CATEGORY_EXTRA_HOURS: "Categoria modificata correttamente.",
      ERROR_UPDATE_CATEGORY_EXTRA_HOURS: "Errore nella modifica della categoria.",
      ERROR_CATEGORY_EXTRA_HOURS_REMOVE: "Errore nell'eliminazione della categoria.",
      SUCCESS_UPDATE_OPTION: "Configurazioni salvata correttamente",
      ERROR_UPDATE_OPTION: "Errore nel salvataggio della configurazione",
      ERROR_OPTION_CANNOT_BE_UPDATED: "L'opzione non può essere modificata",
      SET_AT_LEAST_ONE_DAY: "Inserisci almeno un giorno lavorativo",
      SET_A_RIGHT_QUANTITY: "Imposta una quantità in giorni corretta.",
      SET_MARGIN_UP_TO_ONE: "Imposta un margine superiore a 1.",
      SUCCESS_CREATE_CATEGORY: "Categoria creata con successo.",
      ERROR_CREATE_CATEGORY: "Errore nella creazione della categoria.",
      SUCCESS_UPDATE_CATEGORY: "Categoria modificata correttamente.",
      ERROR_UPDATE_CATEGORY: "Errore nella modifica della categoria.",
      ERROR_CATEGORY_REMOVE: "Errore nell'eliminazione della categoria.",
      SUCCESS_CREATE_SUPPORT_REQUEST: "Richiesta di supporto creata con successo.",
      ERROR_CREATE_SUPPORT_REQUEST: "Errore nella creazione della richiesta di supporto.",
      SUCCESS_EDIT_SUPPORT_REQUEST: "Richiesta di supporto modificata con successo.",
      ERROR_EDIT_SUPPORT_REQUEST: "Errore nella modifica della richiesta di supporto.",
      SUCCESS_DELETE_SUPPORT_REQUEST: "Richiesta di supporto eliminata con successo.",
      ERROR_DELETE_SUPPORT_REQUEST: "Errore nella eliminazione della richiesta di supporto.",
      ERROR_DELETE_FILE: "Errore nella cancellazione del file.",
      SUCCESS_REPLY_SUPPORT_REQUEST: "Risposta alla richiesta di supporto inviata con successo.",
      ERROR_REPLY_SUPPORT_REQUEST: "Errore nell'invio della risposta.",
      SUCCESS_TAKE_CHARGE: "Richiesta di supporto presa in carico con successo.",
      ERROR_TAKE_CHARGE: "Errore nella presa in carica della richiesta di supporto.",
      TO_MANY_HOURS: "Hai superato il limite di ore.",
      SAVE_FIRST_EXTRA_HOUR: "Salva o cancella prima le ore extra che hai attualmente aperte.",
      SAVE_FIRST_REFUND_OPEN: "Salva o annulla prima il bonus che hai attualmente aperto.",
      NOTIFICATION_NOT_FOUND_USER: "Non è possibile aprire il dettaglio della notifica selezionata.",
      SUCCESS_UPDATE_CONTRACT_MANAGER: "Template contratto aggiornato correttamente.",
      ERROR_UPDATE_CONTRACT_MANAGER: "Errore nell'aggiornamento del template contratto.",
      SUCCESS_ASSIGN_EMAIL: "Email associata con successo.",
      ERROR_ASSIGN_EMAIL: "Errore nell'associazione dell'email.",
      ERROR_INVALID_EMAIL: "Email non valida.",
      WORKDAY_REPORT_ERROR_GREATER_VALUE: "Il valore immesso supera quello delle ore extra inserito dall'utente.",
      WORKDAY_REPORT_ERROR_SUM_TOTAL: "La somma tra i due valori è superiore al valore inserito dall'utente.",
      WORKDAY_REPORT_ERROR_TOTAL_NOT_CORRECT: "Attenzione come valore puoi inserire soltanto il totale delle ore extra, se hai inserito dei valori per ogni singola riga saranno azzerati.",
      WORKDAY_REPORT_NOT_FOUND: "Nessun rapportino trovato.",
      ERROR_DELETE_TEMPLATE_DOCUMENT: "Errore nell'eliminazione del template del documento.",
      SUCCESS_CREATE_TEMPLATE_DOCUMENT: "Template documento creato con successo.",
      ERROR_CREATE_TEMPLATE_DOCUMENT: "Errore nella creazione del template.",
      SUCCESS_EDIT_TEMPLATE_DOCUMENT: "Template documento modificato con successo.",
      ERROR_EDIT_TEMPLATE_DOCUMENT: "Errore nella modifica del template.",
      ERROR_INSERT_IBAN: "Errore nell'inserimento del IBAN.",
      INSERT_START_DATE: "Inserisci una data di inizio",
      DOCUMENT_SEND_SUCCESS: "Documento inviato correttamente.",
      DOCUMENT_SEND_ERROR: "Errore nell'invio del documento.",
      REQUEST_RESET_PASSWORD: "Reimpostazione password richiesta con successo. Controlla la tua email.",
      EMAIL_NOT_IN_DATABASE: "L'email inserita non è presente nei nostri database.",
      NO_FILE_UPLOAD: "Nessun file selezionato",
      ERROR_LAST_WIDGET_IN_THE_ARRAY: "Deve essere presente almeno un widget all'interno della colonna.",
      SUCCESS_CREATE_COLLABORATOR: "Collaboratore creato con successo.",
      ERROR_CREATE_COLLABORATOR: "Errore nella creazione del collaboratore.",
      SUCCESS_TRANSFORM_CANDIDATE_TO_COLLABORATOR: "Candidato trasformato a collaboratore con successo.",
      ERROR_TRANSFORM_CANDIDATE_TO_COLLABORATOR: "Errore nella trasformazione del candidato a collaboratore.",
      SUCCESS_EDIT_COLLABORATOR: "Collaboratore modificato con successo.",
      ERROR_EDIT_COLLABORATOR: "Errore nella modifica del collaboratore.",
      ERROR_DELETE_COLLABORATOR: "Errore nell'eliminazione del collaboratore.",
      INSERT_FIRSTNAME_OR_BUSINESS: "Inserisci nome e cognome oppure la ragione sociale.",
      SUCCESS_DISABLE_USER: "Utente disabilitato correttamente.",
      ERROR_DISABLE_USER: "Errore nella disabilitazione dell'utente.",
      SUCCESS_ENABLE_USER: "Utente abilitato correttamente.",
      ERROR_ENABLE_USER: "Errore nella abilitazione dell'utente.",
      INSERT_AVATAR: "Aggiungi un immagine come avatar",
      EMPLOYEE: "Dipendente",
      COLLABORATOR: "Collaboratore",
      SELECT_EMPLOYEE_OR_COLLABORATOR: "Vuoi trasformare il candidato a dipendente o collaboratore?",
      SUCCESS_SEND_TRANSFORMATION: "Trasformazione creata con successo.",
      ERROR_SEND_TRANSFORMATION: "Errore nella creazione dell'iter per la trasformazione.",
      USER_ALREADY_IN_TRANSFORMATION: "È già presente una trasformazione per il collaboratore selezionato.",
      SUCCESS_UPDATE_TRANSFORMATION: "Trasformazione modificata con successo.",
      ERROR_UPDATE_TRANSFORMATION: "Errore nella modifica della trasformazione.",
      SUCCESS_CLOSE_TRANSFORMATION: "Trasformazione chiusa con successo.",
      ERROR_CLOSE_TRANSFORMATION: "Errore nella chiusura della trasformazione.",
      CONFIRM_CLOSE_TRANSFORMATION: "Sei sicuro di voler chiudere la trasformazione?",
      ERROR_NOT_FOUND_TRANSFORMATION: "Nessuna trasformazione trovata.",
      ERROR_REMOVE_TRANSFORMATION: "Errore nella rimozione della trasformazione.",
      ERROR_DISABLE_TRANSFORMATION: "Errore nella disabilitazione della trasformazione.",
      ERROR_RESTORE_TRANSFORMATION: "Errore nell'abilitazione della trasformazione.",
      ERROR_INSERT_FIRSTNAME_LASTNAME_TRANSFORMATION: "Per poter avviare l'iter di trasformazione devi inserire nome e cognome per il collaboratore selezionato.",
      ERROR_DAILY_COST_PRESUMED_EMPTY: "Inserisci costo presunto giornaliero",
      ERROR_VALUE_INSERTED_NOT_VALID: "Il valore inserito non è valido. Sarà resettato a 0",
      ERROR_FIEDLS_EMPTY_OFFICE_SITE: "Alcuni campi delle sedi non sono validi",
      ERROR_FIEDLS_EMPTY_REFERENT: "Alcuni campi dei referenti non sono validi",
      ERROR_ADD_A_OFFICE_LOCATION: "Aggiungi almeno una sede.",
      SUCCESS_GENERATE_REFUND_DOCUMENT: "Documento generato e inviato correttamente.",
      ERROR_GENERATE_REFUND_DOCUMENT: "Errore nella generazione del documento.",
      SUCCESS_ADD_BONUS_EXTRA: "Bonus extra aggiunto correttamente",
      ERROR_ADD_BONUS_EXTRA: "Errore nell'inserimento del bonus extra.",
      SUCCESS_EDIT_BONUS_EXTRA: "Bonus extra modificato correttamente",
      ERROR_EDIT_BONUS_EXTRA: "Errore nella modifica del bonus extra.",
      SUCCESS_DELETE_BONUS_EXTRA: "Bonus extra cancellato correttamente",
      ERROR_DELETE_BONUS_EXTRA: "Errore nella cancellazione del bonus extra.",
      SUCCESS_ADD_BONUS: "Bonus aggiunto correttamente",
      ERROR_ADD_BONUS: "Errore nell'inserimento del bonus.",
      SUCCESS_EDIT_BONUS: "Bonus modificato correttamente",
      ERROR_EDIT_BONUS: "Errore nella modifica del bonus.",
      SUCCESS_CALCULATE_DISTANCE_EMPLOYEE: "Distanza del dipendente calcolata in modo automatico, controlla che sia corretta.",
      ERROR_CALCULATE_DISTANCE_EMPLOYEE: "Ricorda di inserire la distanza del dipendente dalla nostra sede.",
      SUCCESS_CALCULATE_DISTANCE_CUSTOMER: "Distanza del cliente calcolata in modo automatico, controlla che sia corretta.",
      ERROR_CALCULATE_DISTANCE_CUSTOMER: "Ricorda di inserire la distanza del cliente dalla nostra sede.",
      ERROR_HOUR_REQUESTED: "Le ore di permesso possono essere richieste in multipli di 30 minuti.",
      ERROR_HOUR_EXTRA_NOT_INTEGRER: "Le ore ore extra devono essere un numero intero.",
      INSERT_VALID_VALUE_EXTRA_HOUR: "Inserisci un valore corretto nelle ore extra.",
      INSERT_CLOSED_AT_RESIGNATION: "Per le dimissioni devi inserire una data di conclusione.",
      ERROR_RESIDENCE_ADDRESS_INCOMPLETED: "Indirizzo di residenza incompleto",
      ERROR_BILLING_ADDRESS_INCOMPLETED: "Indirizzo di fatturazione incompleto",
      ERROR_LIST_STILL_LOADING: "Prima di poter svolgere qualsiasi azioni attendi il caricamento delle liste.",
      SUCCESS_CREATE_DEAL: "Offerta creata con successo.",
      ERROR_CREATE_DEAL: "Errore nella creazione dell'offerta.",
      SUCCESS_EDIT_DEAL: "Offerta modificata con successo.",
      ERROR_EDIT_DEAL: "Errore nella modifica dell'offerta.",
      SUCCESS_GENERATE_DEAL_DOCUMENT: "Offerta modifica con successo e documento generato correttamente.",
      SUCCESS_GENERATE_DOCUMENT: "Documento generato correttamente.",
      ERROR_GENERATE_DEAL_DOCUMENT: "Errore nella generazione del documento.",
      NOT_FOUND_A_DEAL: "Nessun offerta trovata.",
      ERROR_TOTAL_DEAL: "Errore importo al paragrafo due.",
      COPY: "Copiato",
      INSERT_MIN_4_CHARACCTERS: "Inserisci almeno 4 caratteri",
      REMOVED_EMPLOYEE_PRESENT_DATATABLE: "Hai rimosso un dipendente selezionato nella tabella, il sistema ha rimosso il dipendente dalla tabella.",
      REMOVED_PRODUCT_PRESENT_DATATABLE: "Hai rimosso un prodotto selezionato nella tabella, il sistema ha rimosso il prodotto dalla tabella.",
      NO_DEALS_FOR_SELECTED_CUSTOMER: "Il cliente selezionato non ha nessun offerta disponibile.",
      NO_COMMISSION_FOR_SELECTED_CUSTOMER: "Il cliente selezionato non ha nessuna commessa aperta.",
      ERROR_BILLING_FREQUENCY_INSERT: "Errore nell'inserimento della frequenza di fatturazione.",
      SUCCESS_UPLOAD_BILLING_FREQUENCY: "Frequenza di fatturazione inserita con successo.",
      ERROR_BILLING_FREQUENCY_REMOVE: "Errore nella rimozione della frequenza di fatturazione.",
      SUCCESS_EDIT_BILLING_FREQUENCY: "Frequenza di fatturazione modificata con successo.",
      ERROR_BILLING_FREQUENCY_EDIT: "Errore nella modifica della frequenza di fatturazione.",
      ERROR_PAYMENT_MEASURE_UNIT_INSERT: "Errore nell'inserimento dell' unità di misura.",
      SUCCESS_UPLOAD_PAYMENT_MEASURE_UNIT: "Unità di misura inserita con successo.",
      ERROR_PAYMENT_MEASURE_UNIT_REMOVE: "Errore nella rimozione dell' unità di misura.",
      SUCCESS_EDIT_PAYMENT_MEASURE_UNIT: "Unità di misura modificata con successo.",
      ERROR_PAYMENT_MEASURE_UNIT_EDIT: "Errore nella modifica dell' unità di misura.",
      ERROR_INVOICE_TYPE_INSERT: "Errore nell'inserimento del tipo di fattura.",
      SUCCESS_UPLOAD_INVOICE_TYPE: "Tipo di fattura inserito con successo.",
      ERROR_INVOICE_TYPE_REMOVE: "Errore nella rimozione del tipo di fattura.",
      SUCCESS_EDIT_INVOICE_TYPE: "Tipo di fattura modificato con successo.",
      ERROR_INVOICE_TYPE_EDIT: "Errore nella modifica del tipo di fattura.",
      ERROR_CAUSAL_INSERT: "Errore nell'inserimento della causale.",
      SUCCESS_UPLOAD_CAUSAL: "Causale inserita con successo.",
      ERROR_CAUSAL_REMOVE: "Errore nella rimozione della causale.",
      SUCCESS_EDIT_CAUSAL: "Causale modificata con successo.",
      ERROR_CAUSAL_EDIT: "Errore nella modifica della causale.",
      ERROR_PAYMENT_TERMS_INSERT: "Errore nell'inserimento del termine di pagamento.",
      SUCCESS_UPLOAD_PAYMENT_TERMS: "Termine di pagamento inserito con successo.",
      ERROR_PAYMENT_TERMS_REMOVE: "Errore nella rimozione del termine di pagamento.",
      SUCCESS_EDIT_PAYMENT_TERMS: "Termine di pagamento modificato con successo.",
      ERROR_PAYMENT_TERMS_EDIT: "Errore nella modifica del termine di pagamento.",
      SUCCESS_CREATE_COMMISSION: "Commessa creata con successo.",
      ERROR_CREATE_COMMISSION: "Errore nella creazione della commessa.",
      SUCCESS_EDIT_COMMISSION: "Commessa modificata con successo.",
      ERROR_EDIT_COMMISSION: "Errore nella modifica della commessa.",
      SUCCESS_DELETE_COMMISSION: "Commessa eliminata con successo.",
      ERROR_DELETE_COMMISSION: "Errore nell'eliminazione della commessa.",
      SUCCESS_DELETE_ROUND: "Round eliminato con successo.",
      ERROR_DELETE_ROUND: "Errore nell'eliminazione del round.",
      SUCCESS_DELETE_ORDER: "Ordine eliminato con successo.",
      ERROR_DELETE_ROUND_TO_MANY_REPORTS: "Errore nell'eliminazione del round, il round è collegato ad uno o più rapportini esistenti.",
      ERROR_DELETE_COMMISSION_ROUND_TO_MANY_REPORTS: "Errore nell'eliminazione della commessa, uno o più round ad essa collegata hanno uno o più rapportini approvati.",
      ERROR_NOT_FOUND_COMMISSION: "Nessuna commessa trovata.",
      SUCCESS_CLOSE_COMMISSION: "Commessa chiusa con successo.",
      ERROR_CLOSE_COMMISSION: "Errore nella chiusura della commessa.",
      SUCCESS_REOPEN_COMMISSION: "Commessa riaperta con successo.",
      ERROR_REOPEN_COMMISSION: "Errore nella riapertura della commessa.",
      SUCCESS_REOPEN_ROUND: "Round riaperto con successo.",
      ERROR_REOPEN_ROUND: "Errore nella riapertura del round.",
      SUCCESS_CLOSE_ROUND: "Round chiuso con successo.",
      ERROR_CLOSE_ROUND: "Errore nella chiusura del round.",
      SUCCESS_CREATE_ROUND: "Round creato con successo.",
      ERROR_CREATE_ROUND: "Errore nella creazione del round.",
      SUCCESS_CREATE_ORDER: "Ordine creato con successo.",
      ERROR_CREATE_ORDER: "Errore nella creazione dell'ordine.",
      SUCCESS_EDIT_ROUND: "Round modificato con successo.",
      ERROR_EDIT_ROUND: "Errore nella modifica del round.",
      SUCCESS_EDIT_ORDER: "Ordine modificato con successo.",
      ERROR_EDIT_ORDER: "Errore nella modifica dell' ordine.",
      ERROR_DELETE_ORDER: "Errore nell' eliminazione del round.",
      NOT_FOUND_ROUND: "Nessun round trovato.",
      ERROR_GET_DEAL: "Errore nella selezione dell'offerta, riprova più tardi.",
      ERROR_DATE: "La data di inizio non può essere maggiore della data di fine.",
      ERROR_DATE_ROUND_CONFLICT: "La data di inizio è precedente alla data inizio e fine di alcuni round già presenti",
      ALREADY_PRESENT_A_ROUND:
        "É già presente un round nelle date selezionate. Puoi impostare la data del round precedente al giorno prima del round che stai creando o modificando. Controlla le nuove date e decidi se accettare la nuova data di fine del round precedente oppure di annullare.",
      ALREADY_PRESENT_A_ROUND_DETACHMENT: "É già presente un round nelle date selezionate. Correggi la data di inizio del round che stai creando oppure modifica la data fine del round precedente.",
      ERROR_DEAL_HAS_A_COMMISSION: "L'offerta ha una commessa collegata. Impossibile eliminarla.",
      SUCCESS_SEND_EMAIL_CREDENTIALS: "Credenziali della email aziendale inviate correttamente",
      ERROR_SEND_EMAIL_CREDENTIALS: "Errore nell'invio delle credenziali della email aziendale.",
      INSERT_DATE_END_CONTRACT: "Inserisci data fine contratto.",
      INSERT_DATE_END_LICENSE: "Inserisci data fine licenza.",
      INSERT_CONTRACT: "Inserisci contratto.",
      INSERT_ID_DOCUMENT: "Carica un documento di riconoscimento.",
      INSERT_FISCAL_CODE_FILE: "Carica il tuo codice fiscale.",
      INSERT_PERMIT_DOCUMENT_FILE: "Carica il tuo permesso di soggiorno.",
      YOU_FORGOT_SOME_HOURS_IN_YOUR_REPORT: "Hai dimenticato di assegnare una o più ore. I giorni verranno evidenziati in rosso.",
      YOU_CANNOT_SEND_WORKDAYREPORT_YET: "Non puoi ancora inviare il rapportino mensile",
      INSERT_INVOICE_NUMBER: "Inserisci numero fattura",
      INSERT_AT_ONE_INVOICE: "Devi inviare almeno una fattura.",
      INSERT_AMOUNT_INVOICE: "Inserisci l'importo per il mese di ",
      INSERT_TYPE_INVOICE: "Inserisci il tipo di movimento per il mese di ",
      INSERT_INVOICE_DATE: "Inserisci la data della fattura.",
      SUCCESS_SEND_INVOICE: "Fattura emessa con successo.",
      ERROR_SEND_INVOICE: "Errore nell' emissione della fattura",
      SUCCESS_CREATE_BANK: "Banca creata con successo.",
      ERROR_CREATE_BAN: "Errore nella creazione della banca.",
      SUCCESS_EDIT_BANK: "Banca modificata con successo.",
      ERROR_EDIT_BANK: "Errore nella modifica della banca.",
      ERROR_DELETE_BANK: "Errore nell'eliminazione della banca.",
      ERROR_EMPTY_DETACHMENT_TYPE: "Inserisci tipo di distacco",
      INSERT_AMOUNT_EMPLOYEE: "Ad uno più dipendenti manca l'importo. Mese: ",
      INSERT_ACTIVITY_DETAIL_EMPLOYEE: "Ad uno più dipendenti manca il dettaglio attività. Mese: ",
      INSERT_EMPLOYEE_RATE: "Ad uno più dipendenti non è stata inserita la tariffa. Mese: ",
      INSERT_AMOUNT_EXTRA: "Ad uno più extra manca l'importo. Mese: ",
      INSERT_EXTRA_CAUSAL: "Ad uno più dipendenti manca la causale. Mese: ",
      INSERT_EMPLOYEE_EXTRA: "Ad uno più extra non è stato specificato il dipendente. Mese: ",
      INSERT_EMPLOYEE_NEW_EMPLOYEE: "Ad uno più righe non è stato specificato il dipendente. Mese: ",
      INSERT_EMPLOYEE_HOURS: "Ad uno più dipendenti mancano le ore del rapportino. Mese: ",
      INFO_TOTAL_GREATER_THAN_RESIDUE: "Il totale della fattura è superiore al residuo dell'ordine.",
      FUTURE_EMPLOYEE_ERROR_START_MESSAGE_ONE: "Non è possibile selezionare ",
      FUTURE_EMPLOYEE_ERROR_START_MESSAGE_TWO: ", perché il suo contratto partirà in data ",
      SUCCESS_SET_APPROVAL: "Benestare inserito con successo.",
      ERROR_SET_APPROVAL: "Errore nell'inserimento del benestare.",
      SUCCESS_CREATE_INVOICE: "Fattura create con successo.",
      ERROR_CREATE_INVOICE: "Errore nella creazione della fattura.",
      SUCCESS_SET_INVOICE_CASHED: "Fattura imposta come incassata.",
      ERROR_SET_INVOICE_CASHED: "Errore nell'impostazione della fattura come incassata.",
      SUCCESS_EDIT_INVOICE_NUMBER: "Numero documento modificato con successo.",
      ERROR_EDIT_INVOICE_NUMBER: "Numero documento modificato con successo.",
      SUCCESS_CREATE_CREDIT_NOTE: "Nota di credito create con successo.",
      ERROR_CREATE_CREDIT_NOTE: "Errore nella creazione della nota di credito.",
      SUCCESS_DELETE_CREDIT_NOTE: "Nota di credito eliminata con successo.",
      ERROR_DELETE_CREDIT_NOTE: "Errore nell'eliminazione della nota di credito.",
      SUCCESS_USER_COSTS_MONTHLY_UPDATED: "Costi mensili dei dipendenti inseriti correttamente.",
      ERROR_USER_COSTS_MONTHLY_UPDATED: "Errore nell'inserimento dei costi mensili dei dipendenti.",
      ERROR_DEFUALT_MESSAGE: "C'è stato un errore, riprova.",
      SUCCESS_DEFUALT_MESSAGE: "L'azione è stata completata con successo.",
      SELECT_AT_LEAST_ONE_SKILL: "Seleziona almeno una skill.",
      SELECT_AT_LEAST_ONE_REQUESTED_SKILL: "Imposta almeno una skill obbligatoria.",
      COMPLETE_EDUCATION_SECTION: "Completa correttamente la sezione studi.",
      COMPLETE_FORMATION_SECTION: "Completa correttamente la sezione formazione.",
      INFO_CONTRACT_CURRENT_VALUE_CHANGED: "I campi del contratto corrente sono stati resettati.",
      SUCCESS_UPDATE_EMPLOYEE_RESIDUAL_ABSENCES: "Assenze residue aggiornate correttamente",
      ERROR_UPDATE_EMPLOYEE_RESIDUAL_ABSENCES: "Errore nell'aggiornamento delle assenze residue",
      SUCCESS_UPDATE_EMPLOYEE_RESIGNATION: "Dimissioni inserite con successo",
      NOT_AUTHORIZED: "Non sei autorizzato per visualizzare il contenuto selezionato",
      ERROR_UPDATE_EMPLOYEE_CONTRACT: "Errore nell'aggiornamento del contratto",
      ERROR_UPDATE_EMPLOYEE_CONTRACT_CONTRACT_CLOSED: "Errore nell'aggiornamento del contratto: il contratto risulta già chiuso.",
      SUCCESS_UPDATE_EMPLOYEE_CONTRACT: "Contratto aggiornato con successo",
      CONTRACT_NOT_COMPLETE_MISSING_CONTRACT: "Errore nel contratto: campo tipologia di contratto mancante",
      CONTRACT_NOT_COMPLETE_MISSING_LEVEL: "Errore nel contratto: campo livello mancante",
      CONTRACT_NOT_COMPLETE_MISSING_START_DATE: "Errore nel contratto: campo data d'inizio mancante",
      CONTRACT_NOT_COMPLETE_MISSING_END_DATE: "Errore nel contratto: campo data di chiusura mancante",
      CONTRACT_NOT_COMPLETE_MISSING_PROGRAM: "Errore nel contratto: campo orario mancante",
      CONTRACT_NOT_COMPLETE_MISSING_NET_MONTHLY_12: "Errore nel contratto: campo netto mensile senza tredicesima mancante",
      PLEASE_SELECT_VALID_SINCE_DATE: "Inserisci una data di validità",
      SUCCESS_CLEAR_CACHE: "Cache svuotata con successo.",
      ERROR_CLEAR_CACHE: "Errore nello svuotamento della cache.",
      CONFIRM_GENERATE_WORKDAY_REPORT: "Sei sicuro di voler generare il rapportino di questo dipendente?",
      SUCCESS_GENERATE_WORKDAY_REPORT: "Rapportino generato correttamente",
      ERROR_GENERATE_WORKDAY_REPORT: "Errore nella generazione del rapportino",
      ERROR_NAME_REQUIRED: "Il campo nome è obbligatorio",
      ERROR_ORDER_DATE_NUMBER_REQUIRED: "È stato inserito un file come ordine, controlla di aver inserito data ordine e numero ordine.",
      OPEN_DESCRIPTION_AND_CLOSURE_DESCRIPTION_REQUIRED: "I campi descrizione di apertura e descrizione finale sono obbligatori.",
      ERROR_UPDATE_EMPLOYEE_RESIGNATION: "Errore nella registrazione delle dimissioni/licenziamento del dipendente.",
      CUSTOMER_NOT_FOUND: "Nessun cliente trovato.",
      FIELD_AVATAR: "Inserisci un immagine del profilo.",
      GENERATE_MONTH_AND_YEAR_REQUIRED: "Inserisci mese e anno",
      SUCCESS_GENERATE_INVOICE: "Fattura generate con successo.",
      ERROR_GENERATE_INVOICE: "Errore nella generazione delle fatture.",
      INSERT_FISCALCODE_OR_VAT_NUMBER: "Inserisci partita IVA o Codice fiscale",
      INSERT_DATE: "Inserisci una data",
      COMPILE_ALL_FIELD: "Completa correttamente i campi contrassegnati da *",
      SUCCESS_EXPORT_EXCEL: "Esportazione completata con successo.",
      ERROR_EXPORT_EXCEL: "Errore nell'esportazione del file.",
      SUCCESS_SAVE_TEMPLATE: "Template salvato correttamente",
      ERROR_SAVE_TEMPLATE: "Errore nel salvataggio del template",
      SUCCESS_EDIT_TEMPLATE: "Template modificato correttamente",
      ERROR_EDIT_TEMPLATE: "Errore nella modifica del template",
      SUCCESS_DELETE_TEMPLATE: "Template eliminato correttamente",
      ERROR_DELETE_TEMPLATE: "Errore nell'eliminazione del template",
      INSERT_TEXT: "Inserisci il testo",
      ERROR_NO_ORDER_FROM_PREV_ORDER: "Non sono presenti dati da copiare dal precedente ordine",
      ERROR_DUPLICATE_DEAL: "Errore nella duplicazione dell'offerta dal round precedente",
      SUCCESS_UPDATE_COMPANY_EMAIL: "Email aziendale aggiornata con successo.",
      ERROR_UPDATE_COMPANY_EMAIL: "Errore nell'aggiornamento dell'email aziendale.",
      PLEASE_UPLOAD_PDF_FILE: "Inserisci un file PDF",
      ERROR_REGENERATING_ANALYTICS: "Errore nella rigenerazione del dettaglio economico mensile.",
      SUCCESS_REGENERATING_ANALYTICS: "Dettagli economici mensili rigenerati con successo.",
      NO_ORDERS_FOR_THIS_MONTH: "Nessun ordine trovato per questo mese.",
      WORKDAY_REPORT_DOWNLOADED: "Rapportino mensile scaricato correttamente, controlla i download.",
      SUCCESS_LINK_TO_ECONOMIC_DETAIL: "Riga collegata correttamente al dettaglio economico.",
      ERROR_LINK_TO_ECONOMIC_DETAIL: "Errore nel collegamento della riga collegata al dettaglio economico.",
      UNABLE_LINK_TO_ECONOMIC_DETAIL: "Impossibile collegare la riga collegata al dettaglio economico. Controlla i parametri inseriti.",
      A_FEW_LINES_ARE_MISSING_THE_LINK_TO_ANALYTICS: "In una o più righe manca il collegamento con il dettaglio economico."
    },
    ERRORS: {
      INSERT_AMOUNT: "Inserisci importo",
      FIELD_CODE: "Il campo codice è obbligatorio",
      FIELD_CERTIFICATION: "Il campo certificazione è obbligatorio",
      FIELD_NAME: "Il campo nome è obbligatorio",
      FIELD_LIST_ROLES: "Il campo lista ruoli è obbligatorio",
      FIELD_COLLABORATOR: "Il campo collaboratore è obbligatorio",
      INSERT_INVOICE_NUMBER: "Il campo numero fattura è obbligatorio",
      INSERT_INVOICE_DATE: "Il campo data fattura è obbligatorio",
      INSERT_INVOICE_WORKING_HOURS: "Il campo ore è obbligatorio",
      INSERT_INVOICE_EXTRA_CAUSAL: "Il campo causale è obbligatorio",
      INSERT_INVOICE_EMPLOYEE_AMOUNT: "Il campo importo dipendente è obbligatorio",
      INSERT_INVOICE_ACTIVITY_DETAIL: "Il campo dettaglio attività è obbligatorio",
      INSERT_INVOICE_TOTAL_AMOUNT: "Il campo importo totale fattura è obbligatorio",
      INSERT_INVOICE_EMPLOYEE_EXTRA: "Il campo importo extra è obbligatorio",
      INSERT_INVOICE_AMOUNT: "Il campo importo è obbligatorio",
      FIELD_TYPE_ABSENCE: "Tipo di assenza obbligatorio",
      INSERT_TYPE_HOLIDAY: "Inserisci tipo di ferie",
      INSERT_BIC_SWIFT: "Il campo BIC è obbligatorio",
      MIN_BIC_SWIFT: "Il campo BIC deve essere minimo di 8 caratteri.",
      MAX_BIC_SWIFT: "Il campo BIC deve essere massimo di 11 caratteri.",
      INSERT_IBAN: "Il campo iban è obbligatorio",
      MIN_IBAN: "Il campo iban deve essere lungo minimo 15 caratteri.",
      MAX_IBAN: "Il campo iban deve essere lungo massimo 36 caratteri.",
      INSERT_TYPE_SICKNES: "Inserisci tipo di malattia",
      INSERT_MEDICAL_CERTIFICATE_PROTOCOL: "Inserisci protocollo",
      INSERT_TYPE_PERMISSION: "Inserisci tipo di permesso",
      SELECT_DESTINATORY: "Seleziona un destinatario",
      SELECT_EMPLOYEE: "Seleziona un dipendente",
      SELECT_MAINTENANCE: "Seleziona una manutenzione",
      INSERT_TYPEOLOGY_DOCUMENT: "Il campo tipologia di documento è obbligatorio",
      SELECT_JOB_SITE: "Seleziona modalità di lavoro",
      SELECT_CCNL: "Metalmeccanico",
      INSERT_NOTE: "Inserisci nota",
      SELECT_CITY: "Seleziona città",
      CATEGORY_NOT_VALID: "Categoria non valida",
      SELET_A_CATEGORY: "Seleziona una categoria",
      SELECT_CATEGORY_MIN: "Seleziona almeno una categoria",
      INSERT_NAME: "Il campo nome è obbligatorio",
      INSERT_CODE: "Inserisci il codice",
      INSERT_DESCRIPTION: "Inserisci la descrizione dettagliata",
      FIELD_RATE: "Il campo tariffa è obbligatorio",
      INSERT_MIN_LENGTH: "Inserisci almeno",
      INSERT_TITLE: "Inserisci il Titolo",
      INSERT: "Inserisci",
      CHARACTERS: "Caratteri",
      INSERT_SHORT_DESCRIPTION: "Inserisci la descrizione breve per gli elenchi",
      INSERT_LONG_DESCRIPTION: "Inserisci la descrizione dettagliata",
      SELECT_MIN_ONE: "Seleziona una o più categorie ",
      SELECT_MODE: "Seleziona una modalità",
      SELECT_GENDER: "Seleziona il genere",
      SELECT_CONTRACT: "Seleziona un tipo di contratto",
      SELECT_MODE_ERROR: "Seleziona una modalità di lavoro",
      INSERT_CITY: "Seleziona almeno una o più città",
      INSERT_KM: "Inserisci la distanza in km dalla nostra sede A/R",
      SELECT_CITY_MIN: "Seleziona almeno una città",
      CITY_NOT_VALID: "Città non valida",
      INSERT_DETACHMENT_TYPE: "Seleziona tipo di distacco",
      INSERT_ONE_CITY: "Il campo città è obbligatorio",
      NOT_VALID: "Non valida",
      INSERT_INVOICE: "Seleziona una fattura",
      CONTRACT_NOT_VALID: "Contratto non valido",
      CONTROL_FISCAL_CODE: "Il codice fiscale è stato generato automaticamente, controlla che sia corretto",
      INSERT_LASTNAME: "Il campo cognome è obbligatorio",
      INSERT_PHONE: "Il campo cellulare è obbligatorio",
      INSERT_PRIVATE_PHONE: "Il campo cellulare privato è obbligatorio",
      INSERT_PRIVATE_EMAIL: "Il campo email privata è obbligatorio",
      INSERT_VALID_EMAIL: "Inserisci un email valida",
      INSERT_ADDRESS: "Il campo indirizzo è obbligatorio",
      INSERT_ZIP_CODE: "Il campo C.A.P. è obbligatorio",
      INSERT_BIRTHDAY: "Il campo data di nascita è obbligatorio",
      INSERT_BIRTH_PLACE: "Il campo luogo di nascita è obbligatorio",
      INSERT_FISCAL_CODE: "Il campo codice fiscale è obbligatorio",
      INSERT_TYPE_DOCUMENT: "Il campo tipo di documento è obbligatorio",
      INSERT_TYPE_NATIONALITY: "Il campo tipo di nazionalità è obbligatorio",
      INSERT_TUTOR: "Il campo tutor è obbligatorio",
      INSERT_DOCUMENT_NUMBER: "Il campo numero di documento è obbligatorio",
      INSERT_DOCUMENT_EXPIRE: "Il campo scadenza documento è obbligatorio",
      INSERT_PROVINCE: "Il campo provincia è obbligatorio",
      INSERT_COUNTRY: "Il campo paese è obbligatorio",
      INSERT_SEX: "Il campo genere è obbligatorio",
      INSERT_VAT_NUMBER: "Il campo partita IVA è obbligatorio",
      INSERT_NATIONALITY: "Il campo nazionalità è obbligatorio",
      INSERT_CITY_REQUIRED: "Il campo città è obbligatorio",
      INSERT_OFFICE_EMAIL: "Il campo email aziendale è obbligatorio",
      ATTENTION_SOCIAL: "Attenzione, tutti gli url che inserirai saranno pubblici all'interno della piattaforma e dovranno rimandare ai tuoi canali social privati.",
      INSERT_EDUCATION_TITLE: "Il campo titolo di studio è obbligatorio",
      INSERT_RECORD: "Il campo record è obbligatorio",
      INSERT_EDUCATION_COURSE: "Il campo indirizzo di studio è obbligatorio",
      INSERT_EDUCATION_SCHOOL: "Il campo facoltà è obbligatorio",
      INSERT_VOTE: "Il campo voto è obbligatorio",
      INSERT_WORKING_CITY: "Il campo città lavorativa è obbligatorio",
      INSERT_START_DATE: "Il campo data inizio è obbligatorio",
      INSERT_END_DATE: "Il campo data fine è obbligatorio",
      INSERT_EMAIL: "Il campo email è obbligatorio",
      EMPLOYEES_REQUIRED: "Il campo dipendenti è obbligatorio",
      EMPLOYEE_REQUIRED: "Il campo dipendente è obbligatorio",
      FIELD_BANK: "Il campo banca è obbligatorio",
      CUSTOMER_REQUIRED: "Il campo cliente è obbligatorio",
      INSERT_COMMERCIAL: "Il campo commerciale è obbligatorio",
      ADD_NEW_SKILL: "Aggiungi nuova skill",
      ADD_NEW_CERTIFICATE: "Aggiungi nuova certificazione",
      INSERT_MESSAGE: "Inserisci messaggio",
      INSERT_CUSTOMER: "Inserisci cliente",
      INSERT_CUSTOMER_REFERENCE: "Inserisci referente aziendale",
      INSERT_CUSTOMER_COMMERCIAL: "Inserisci referente commerciale",
      INSERT_FIGURE_PARAM: "Inserisci parametro per la figura professionale",
      INSERT_SKILLS_REQUIRED_PARAM: "Inserisci parametro per le skill obbligatorie",
      INSERT_SKILLS_OPTIONALS_PARAM: "Inserisci parametro per le skill gradite",
      INSERT_CITY_PARAM: "Inserisci parametro per la città",
      INSERT_SITE_PARAM: "Inserisci parametro per la modalità di lavoro",
      INSERT_RATE_PARAM: "Inserisci parametro per la tariffa",
      INSERT_CERTIFICATIONS_PARAM: "Inserisci parametro per le certificazioni",
      INSERT_LANGUAGES_PARAM: "Inserisci parametro per le lingue",
      INSERT_EDUCATION_TITLE_PARAM: "Inserisci parametro per il titolo di studi",
      INSERT_ZIPCODE: "Il campo codice postale è obbligatorio",
      INSERT_LABEL: "Il campo label è obbligatorio",
      INSERT_LANGUAGE: "Il campo lingua è obbligatorio",
      INSERT_OWNER: "Inserisci il proprietario del gruppo.",
      ERROR_USER_DATA_INSERT: "Errore nell'inserimento dei dati, riprova fra qualche minuto. Se l'errore persiste contatta lo staff.",
      INSERT_DESIRED_SITE: "Il campo modalità di lavoro è obbligatorio",
      INSERT_RAL: "Il campo RAL è obbligatorio",
      INSERT_LEVEL: "Il campo livello è obbligatorio",
      INSERT_TYPE_CONTRACT: "Il campo tipologia di contratto è obbligatorio",
      commission_analytics_deleted_because_it_should_not_exists: "Dettaglio economico rimosso perché, in base alla durata del round, non dovrebbe esistere.",
      email_address_already_in_use: "Indirizzo email già utilizzato.",
      phone_number_already_in_use: "Numero di telefono già utilizzato.",
      invalid_phone: "Il numero di telefono inserito non è valido.",
      INSERT_SERIAL: "Il campo seriale è obbligatorio",
      INSERT_OFFICE_SITE: "Il campo sede è obbligatorio.",
      INSERT_OBJECT: "Il campo oggetto è obbligatorio.",
      INSERT_BILLING_FREQUENCY: "Il campo frequenza di fatturazione è obbligatorio.",
      INSERT_PAYMENT_MEASURE_UNIT: "Il campo unità di misura è obbligatorio.",
      INSERT_INVOICE_TYPE: "Il campo tipo di fattura è obbligatorio.",
      INSERT_PAYMENT_TERMS: "Il campo termini di pagamento è obbligatorio.",
      INSERT_FROM: "Il campo data dal è obbligatorio.",
      INSERT_TO: "Il campo data al è obbligatorio.",
      INSERT_TRANCHE_IMPORT: "Il campo importo tranche è obbligatorio.",
      INSERT_TRANCHE_NUMBER: "Il campo n.tranche è obbligatorio.",
      DESCRIPTION_MAX_LENGTH: "Hai superato la lunghezza massima per la descrizione.",
      INSERT_CAPACITY: "Il campo capienza è obbligatorio.",
      INSERT_SERIAL_PRODUCT: "Il campo seriale prodotto è obbligatorio",
      INSERT_CATEGORY: "Inserisci una categoria",
      FIELD_MESSAGE: "Il campo messaggio è obbligatorio",
      FIELD_SURNAME: "Il campo cognome è obbligatorio",
      FIELD_COMPANY: "Il campo azienda è obbligatorio",
      FIELD_BUSINESS_NAME: "Il campo ragione sociale è obbligatorio",
      FIELD_VAT_NUMBER: "Il campo partita IVA è obbligatorio",
      FIELD_OFFICE_SITE: "Il campo sede è obbligatorio",
      FIELD_FIGURE_PROFESSIONAL: "Il campo figura professionale è obbligatorio",
      FIELD_FIGURE: "Il campo figura è obbligatorio",
      FIELD_ROLE: "Il campo ruolo è obbligatorio",
      FIELD_ORDER: "Il campo ordine è obbligatorio",
      FIELD_OBJECT: "Il campo oggetto è obbligatorio",
      FIELD_EMPLOYEES: "Il campo dipendenti è obbligatorio",
      FIELD_SKILLS: "Il campo skills è obbligatorio",
      FIELD_SKILL: "Il campo skill è obbligatorio",
      FIELD_CUSTOMER: "Il campo cliente è obbligatorio",
      FIELD_COMMERCIAL: "Il campo commerciale è obbligatorio",
      FIELD_TOTAL_DAILY: "Il campo costo presunto giornaliero è obbligatorio",
      FIELD_SENIORITY: "Il campo seniority è obbligatorio",
      FIELD_SOURCE: "Il campo fonte è obbligatorio",
      FIELD_CATEGORY_DOCUMENT: "Il campo categoria documento è obbligatorio",
      FIELD_CATEGORY: "Il campo categoria è obbligatorio",
      FIELD_VAT: "Il campo IVA è obbligatorio",
      FIELD_VAT_MIN: "Il valore del campo IVA deve essere minimo 0.",
      FIELD_VAT_MAX: "Il valore del campo IVA deve essere massimo 100.",
      FIELD_MONTH_VALUE_MIN: "Il campo valore in mesi deve essere minimo 1.",
      FIELD_DAY_VALUE_MAX: "Il campo valore in giorni deve essere massimo 365.",
      FIELD_DAY_VALUE_MIN: "Il campo valore in giorni deve essere minimo 1.",
      FIELD_MONTH_VALUE_MAX: "Il campo valore in mesi deve essere massimo 12.",
      FIELD_CATEGORY_PARENT: "Il campo categoria genitore è obbligatorio",
      FIELD_DESCRIPTION: "Il campo descrizione è obbligatorio",
      FIELD_DOMAIN: "Il campo dominio è obbligatorio",
      FIELD_DOCIMENTS: "Il campo documenti è obbligatorio",
      FIELD_TITLE: "Il campo titolo è obbligatorio",
      INVALID_CHARACTER_INSERTED: "Inserito carattere non idoneo",
      INSERT_DATE: "Inserisci una data",
      INSERT_FILE: "Inserisci file",
      FIELD_REQUEST_IBAN_CHARACTERS: "Richiesti 27 caratteri",
      INSERT_CREDIT_NOTE_DATE: "Il campo data nota di credito è obbligatorio",
      INSERT_CREDIT_NOTE_NUMBER: "Il campo n.nota di credito è obbligatorio",
      CIG_MAX_LENGTH: "Il campo CIG deve essere lungo 10 caratteri",
      CUP_MAX_LENGTH: "Il campo CUP deve essere lungo 15 caratteri",
      SELECT_COLLABORATOR: "Seleziona un collaboratore"
    },
    MISC: {
      PAGE_NOT_FOUND: "Pagina non trovata ",
      BACK_TO_HOME: "Torna alla home",
      MISC_PAGE_REMOVED: "La pagina che cerchi potrebbe essere stata rimossa o aver cambiato URL."
    },
    DATATABLE_COLUMNS: {
      SHOW_COLUMNS: "Mostra colonne",
      NAME: "Nome",
      CODE: "Codice",
      ID: "ID",
      DESCRIPTION: "Descrizione",
      ROLES: "Ruoli",
      ROLE_IDS: "Id Ruoli",
      TYPE: "Tipo",
      REQUIRE_NOTE: "Richiede nota",
      REQUIRE_FILE: "Richiede file",
      TYPE_ABSENCE: "Tipo di assenza",
      REQUIRE: "Richiede",
      USES_NUMBER: "Numero usi",
      INITIALS: "Sigla",
      PROVINCE: "Provincia",
      REGION: "Regione"
    },
    ROLES: "Ruoli",
    DOCUMENTS: "Documenti",
    DEPARTMENT: "Dipartimento",
    CAPABILITY: "Permesso",
    CAPABILITIES: "Permessi utente",
    ACCORDING_PERMISSIONS_TO_ROLE: "Assegna permessi a ruoli utenti",
    ASSIGN: "Assegna",
    LIST: "Lista",
    CREATE_BARGAINING: "Crea contrattazione",
    SHOW: "Mostra",
    SEARCH: "Cerca",
    ENTRIES: "elementi",
    VIEW_SALES: "Guarda le vendite",
    STATISTICS: "Statistiche",
    SALES: "Vendite",
    CUSTOMERS: "Clienti",
    PRODUCTS: "Prodotti",
    REVENUE: "Fatturato",
    UPDATED: "Aggiornato",
    MONTH_AGO: "mese fa",
    MONTHS_AGO: "mese fa",
    CALENDAR: "Calendario",
    ADD_JOB_POSITION: "Aggiungi posizione",
    EDIT_JOB_POSITION: "Modifica posizione",
    JOB_POSITIONS_LIST: "Elenco Posizioni",
    ADD_CAPABILITY: "Aggiungi permesso",
    EDIT_CAPABILITY: "Modifica permesso",
    ADD_CITY: "Aggiungi Città",
    EDIT_CITY: "Modifica Città",
    ADD_TYPE_ABSENCE: "Aggiungi tipo di assenza",
    EDIT_TYPE_ABSENCE: "Modifica tipo di assenza",
    COMMENT: {
      POST: "Invia commento",
      ADD: "Aggiungi commento"
    },
    BACK: "Indietro",
    IMPORT: "Importa",
    SAVE: "Salva",
    ADD: "Aggiungi",
    EDIT: "Modifica",
    DELETE: "Elimina",
    ACTIVE: "Attiva",
    IN_PROGRESS: "In corso",
    COMPLETE: "Completata",
    DEACTIVE: "Disattiva",
    ACTIVATE: "Attive",
    DEACTIVATE: "Disattivate",
    DEACTIVATE_SINGULAR: "Disattivata",
    FRIENDS: "Amici",
    PHOTOS: "Foto",
    PHONE: "Cellulare",
    WEBSITE: "Sito web",
    SUGGESTIONS: "Suggerimenti",
    LATEST_PHOTOS: "Ultime foto",
    NEXT: "Avanti",
    POLLS: "Sondaggi",
    POLLS_DESCRIPTION: "Chi è il miglior attore del Marvel Cinematic Universe?",
    REQUIRED_FIELD: "Campo obbligatorio",
    FIELD: "Campo",
    PROFILE: {
      ABOUT: "Chi sono",
      LIVES: "Vive a",
      JOINED: "Ingresso in azienda"
    },
    DEMANDS: {
      HOLIDAYS: "Ferie",
      PERMISSIONS: "Permessi",
      SICKNESS: "Malattie"
    },
    LANDING: {
      HEADER_TITLE: "Qui potrai scaricare, firmare e rimandare il tuo contratto!",
      INSERT_DATA: "Inserisci i dati ed entra",
      JOIN_GROUP: "a far parte del",
      TEAM_NAME: "team Nepta"
    },
    TYPE_ABSENCES: {
      ferie: "Ferie",
      permesso: "Permesso",
      malattia: "Malattia",
      infortunio: "Infortunio",
      maternità: "Maternità",
      "ore non retribuite": "Ore non retribuite",
      altro: "Altro"
    },
    SAVE_EDIT: "Salva modifiche",
    CHANGE_PASSWORD: "Cambia password",
    OLD_PASSWORD: "Vecchia password",
    CURRENT_PASSWORD: "Password attuale",
    NEW_PASSWORD: "Nuova password",
    CONFIRM_PASSWORD: "Conferma password",
    CONTRACT: "Contratto",
    ID_DOCUMENT: "Documento d'identità",
    ID_DOCUMENTS: "Documenti d'identità",
    DOCUMENTS_AREA: "Area documenti",
    ESSENTIAL_DOCUMENTS: "Documenti Essenziali",
    PERSONAL_DOCUMENT: "Documenti personali",
    RESIDENCE_INFORMATION: "Informazioni di Residenza",
    INFORMATIONS: "Informazioni",
    IDENTIFICATION_CODE: "Codice Identificativo",
    SOCIAL_LINKS: "Link social",
    SOCIALS: "Social",
    COMMUNICATIONS_HISTORY: "Storico Comunicazioni",
    CREATION_USER: "Creazione dell'utente",
    CREATED_BY: "Creato da",
    CREATED_THE: "Creato il",
    PRIVATE_DATA: "Dati privati",
    HELLO: "Ciao",
    SECOND: "secondo",
    SECONDS: "secondi",
    MINUTE: "minuto",
    MINUTES: "minuti",
    HOUR: "ora",
    HOURS: "ore",
    DAY: "giorno",
    DAYS: "giorni",
    MONTH: "mese",
    MONTHS: "mesi",
    YEAR: "anno",
    YEARS: "anni",
    DETAIL: "Dettagli",
    CITY: "Città",
    DESIRED_CITY: "Città desiderata",
    CITIZENSHIP: "Cittadinanza",
    SEND: "Invia",
    FIRSTNAME: "Nome",
    LASTNAME: "Cognome",
    FIRSTNAME_AND_LASTNAME: "Nome e cognome",
    CATEGORIES: "Categorie",
    CATEGORY: "Categoria",
    COMPETENCE: "Competenze",
    SINGLE_COMPETENCE: "Competenza",
    GENDER: "Genere",
    REGION: "Regione",
    CAPITAL_CITY: "Capoluogo di provincia",
    PROVINCE_INITIALS: "Sigla provinciale",
    SEND_ONBOARDING: "Invia onboarding",
    WORKING_CITY: "Città in cui lavora",
    RESIDENCE_CITY: "Città di residenza",
    BIRTHDAY: "Data di nascita",
    BIRTH_PLACE: "Luogo di nascita",
    USER_OFFICE_EMAIL: "Email aziendale",
    ASSUMPTION_DATE: "Data di assunzione",
    RESUME: "Riepilogo",
    MASTERDATA: "Anagrafica",
    SENIORITY: "Seniority",
    SET_AS_PRIMARY_SKILL: "Imposta come principale",
    ADDRESS: "Indirizzo",
    ADDRESSES: "Indirizzi",
    ADDRESS_DOMICILE: "Indirizzo di domicilio",
    RESIDENCE_ADDRESS: "Indirizzo di residenza",
    LIVING_SHIPPING_ADDRESS: "Indirizzo di domicilio/spedizione",
    SHIPPING_ADDRESS: "Indirizzo di domicilio",
    ADDRESS_STREET: "Indirizzo",
    ADDRESS_STREET_PLACEHOLDER: "Via/Piazza e n° civico",
    ADDRESS_STREET_REQUIRED: "Il campo indirizzo è obbligatorio",
    ADDRESS_REGION_REQUIRED: "Il campo regione è obbligatorio",
    ADDRESS_ZIPCODE: "C.A.P.",
    ADDRESS_ZIPCODE_PLACEHOLDER: "00000",
    ADDRESS_ZIPCODE_REQUIRED: "Il campo C.A.P. è obbligatorio",
    ADDRESS_DISTANCE_REQUIRED: "Il campo distanza è obbligatorio",
    ADDRESS_DISTANCE_MAX: "Hai superato il limite massimo di 2000Km",
    ADDRESS_PROVINCE: "Provincia",
    ADDRESS_DISTANCE: "Distanza dalla nostra sede A/R",
    PROVINCE: "Provincia",
    IS_PROVINCE: "La città che stai inserendo è una provincia?",
    ADDRESS_PROVINCE_REQUIRED: "Il campo provincia è obbligatorio",
    ADDRESS_CITY_REQUIRED: "Il campo città è obbligatorio",
    PROVINCE_INITIALS_REQUIRED: "Il campo sigla provinciale è obbligatorio",
    ADDRESS_SAME_RESIDENCE: "Usa l'indirizzo di residenza",
    CHILD_NUMBER: "Numero di figli",
    FIGURE: "Figura",
    SELECT_FIGURE: "Seleziona figura",
    PROFESSIONAL_FIGURE: "Figura professionale",
    SELECT_PROFESSIONAL_FIGURE: "Seleziona una figura professionale",
    ROLE: "Ruolo",
    FISCAL_CODE: "Codice fiscale",
    LOAD_FISCAL_CODE: "Carica codice fiscale",
    NATIONALITY: "Nazionalità",
    INFO: "Informazioni",
    HAS_CHILD: "Ha figli",
    MODE: "Modalità",
    ALL: "Tutti",
    ALL_FEMALE_PLURAL: "Tutte",
    TOTAL: "Totali",
    NO: "No",
    YES: "Sì",
    CANCEL: "Annulla",
    DISCARD: "Svuota",
    RESET: "Reset",
    NEW: "nuovo",
    ADD_NEW: "Aggiungi nuovo",
    REMOVE: "Rimuovi",
    MAN: "Uomo",
    WOMAN: "Donna",
    NOT_BINARY: "Non binario",
    NOT_SPECIFIED: "Preferisco non specificare",
    MALE: "Maschile",
    FEMALE: "Femminile",
    OTHER: "Altro",
    RECEIVED: "Ricevuta",
    NOT_RECEIVED: "Non ricevuta",
    REQUIRED: "Richiesto",
    NOT_REQUIRED: "Non richiesto",
    ACTIONS: "Azioni",
    COMPLETED: "Completato",
    NOT_COMPLETED: "Da completare",
    AWARDS_BOARD: "Bacheca Premi",
    USER_TYPE: "Tipo di utente",
    COUNTRY: "Paese",
    PRIVATE_EMAIL: "Email privata",
    PRIVATE_PHONE: "Cellulare privato",
    CIVIL_STATUS: "Stato civile",
    EMERGENCY_CONTACT: "Contatto di emergenza",
    GO_TO_CURRICULUM: "Visualizza il Curriculum",
    GO_TO_CONTRACT: "Visualizza dati contrattuali",
    HR_REFERENCE: "Recruiter",
    EDUCATION_TITLE: "Titolo di studi",
    EDUCATION_SUBJECT: "Materia di studi",
    HAS_WELCOMEBOX: "Nepta box",
    NEED_ASSETS: "Ha bisogno di assets",
    ASSETS: "Assets",
    DUTY: "Mansione",
    EXPORT_EXCEL: "Esporta in excel",
    EXPORT: "Esporta",
    SET_ONBOARDING_FINISHED: "Imposta processo di on boarding come completato",
    NO_COMMUNICATIONS: "Nessuna comunicazione.",
    NO_COMMUNICATIONS_WITH_CURRENT_KEYS: "Nessuna comunicazione presente con questi parametri.",
    NO_EXPERIENCES_FOR_THIS_USER: "Nessuna esperienza per questo utente",
    NO_SKILL_FOR_THIS_USER: "Nessuna competenza per questo utente",
    NO_LANGUAGES_FOR_THIS_USER: "Nessuna lingua per questo utente",
    NO_CERTIFICATION_FOR_THIS_USER: "Nessuna certificazione per questo utente",
    KNOWN_LANGUAGES: "Lingue conosciute",
    FOREIGN_LANGUAGES: "Lingue Straniere",
    LANGUAGE: "Lingua",
    LEVEL_SPEAK: "Livello parlato",
    LEVEL_WRITE: "Livello scritto",
    GO_TO_DOCUMENTS_LIST: "Visualizza i documenti",
    LEVEL: "Livello",
    START_DATE: "Data inizio",
    END_DATE: "Data fine",
    FROM_PERIOD: "Dal",
    TO_PERIOD: "Al",
    INITIALS: "Iniziali",
    CONTACTS: "Contatti",
    NO_FOUND_CONTACTS: "Non ci sono contatti",
    CONTRACT_TRIAL: "Periodo di prova",
    CONTRACT_TRIAL_DAYS: "Periodo di prova (in giorni)",
    CONTRACT_PROGRAM: "Orario",
    JOB_SITE: "Modalità di lavoro",
    FULLTIME: "Tempo pieno",
    PARTTIME: "Tempo parziale",
    DURATION: "Durata contratto (in mesi)",
    CONTRACT_DURATION: "Durata contratto",
    PERIOD: "Periodo",
    TOTAL_EFFORT: "Effort totale",
    ACTIVITY_NAME: "Nome attività",
    MONTHLY_CANON: "Canone mensile",
    CURRENT_CONTRACT: "Contratto corrente",
    CONTRACT_TYPE: "Tipologia di contratto",
    MONTHLY_BONUSES: "Bonus mensili",
    SALARY_MONTH: "Netto mensile",
    BONUS_TICKET: "Buoni pasto",
    TICKET_CARD: "Numero card",
    TICKET_MONTH_NUMBER: "Numero ticket per mese",
    TICKET_VALUE: "Valore dei ticket",
    TICKET_DAILY_VALUE: "Valore giornaliero dei ticket",
    TICKET_TYPE: "Tipologia erogazione",
    STATIC: "Fisso",
    DYNAMIC: "Dinamico",
    VARIABLE: "Variabile",
    EMPLOYEE_COST: "Costo dipendente",
    FIRE_FIELDS: "Licenziamento",
    RESIGNATION_OR_FIRE_FIELDS: "Dimissioni e licenziamento",
    CLOSED_AT: "Data conclusione",
    CLOSED_REASON: "Motivo conclusione",
    RESIGNATION_FILE: "File INPS per rassegnazione dimissioni",
    DISMISSAL_FILE: "Carica lettera di licenziamento",
    CHOOSE_FILE: "Seleziona un file",
    FILE_ALREADY_UPLOADED: "File già caricato",
    DOCUMENT_TYPE: "Tipo di documento",
    DOCUMENT_NUMBER: "Numero documento",
    VALID_UNTIL: "Valido fino al",
    VALID_SINCE: "Valido dal",
    DOCUMENT_ID: "Documento d'Identità",
    DOCUMENT_EXPIRE: "Scadenza documento",
    SELECT_DOCUMENT_ID_FILE: "Seleziona il documento d'identità",
    SELECT_FISCAL_CODE_FILE: "Seleziona il codice fiscale",
    SELECT_RESIDENCE_PERMIT_FILE: "Seleziona il permesso di soggiorno",
    SELECT_YEAR: "Seleziona anno",
    MANAGEMENT_FIELDS: "Campi di gestione utente",
    RESIDENCE_PERMIT: "Permesso di soggiorno",
    RESIDENCE_PERMIT_NUMBER: "Numero permesso di soggiorno",
    RESIDENCE_PERMIT_VALID_UNTIL: "Scadenza permesso di soggiorno",
    SKILLS: "Skills",
    SKILL: "Skill",
    ENABLE_SKILL: "Vuoi impostare la skill come attiva?",
    ENABLE_CERTIFICATE: "Vuoi impostare la certificazione come attiva?",
    EXPERIENCES: "Esperienze",
    EXPERIENCES_CV: "Esperienze CV",
    JUNIOR: "Junior",
    NO_ONE_DOCUMENT_UPLOADED: "Nessun documento caricato.",
    ON_STUDING: "Attualmente in fase di studio?",
    COURSE_STUDY: "Indirizzo di studio",
    EDUCATION_ONBOARDING: "Formazione",
    SCHOOL: "Facoltà",
    MIDDLE: "Middle",
    SENIOR: "Senior",
    EXPERIENCE_DETAIL: "Dettaglio esperienza",
    DESCRIBE_YOUR_EXPERIENCE: "Vogliamo sapere di più di te! Raccontaci le tue esperienze progettuali a cui hai preso parte, inserendole dalla più recente.",
    PROFESSIONAL_EXPERIENCES: "Esperienze Professionali",
    EDUCATION: "Studi",
    EDUCATION_VOTE: "Voto",
    WORK: "Lavoro",
    WORK_EXPERIENCE: "Lavorative",
    LANGUAGES: "Lingue",
    CERTIFICATIONS: "Certificazioni",
    FILTER: "Filtra",
    FILTER_CATEGORY: "Filtra per categoria",
    FILTER_STATE: "Filtra per stato",
    PRICE: "Prezzo",
    AND: "e",
    FROM: "Dal",
    TO: "Al",
    REQUESTED_DATE: "Richiesto il",
    APPROVED: "Approvato",
    NOT_APPROVED: "Non approvato",
    AGENCY_NAME: "Nome azienda",
    DOMAIN: "Dominio",
    DESCRIPTION: "Descrizione",
    SHORT_DESCRIPTION: "Descrizione breve",
    PRODUCT: "Prodotto",
    PUBLICATION_DATE: "Data pubblicazione",
    STATE: "Stato",
    HOW_MANY_USERS_GROUP: "Componenti del gruppo",
    HOW_MANY_USER_SKILL: "Utenti con questa skill",
    HOW_MANY_USER_CERTIFCATE: "Utenti con questa certificazione",
    TECNOLOGIES: "Tecnologie",
    NAME: "Nome",
    PROOF: "Prova",
    VALIDATY_PROOF: "Prova di validità",
    LANGUAGE_LEVELS: {
      A1: {
        LABEL: "Utente di base",
        DESCRIPTION: "Si rientra in questo livello se si possiede una conoscenza base della lingua. Si riesce a compiere interazioni semplici e a presentare se stessi o altre persone."
      },
      A2: {
        LABEL: "Utente di base",
        DESCRIPTION:
          "Si rientra in questo livello se si riesce a partecipare a semplici dialoghi, utilizzando termini semplici e di uso comune e quotidiano. Si riescono a descrivere anche aspetti e situazioni della vita quotidiana."
      },
      B1: {
        LABEL: "Utente autonomo",
        DESCRIPTION:
          "In questo livello si riescono a comprendere testi semplici o intermedi, riguardanti argomenti e tematiche conosciute. Si riesce a muoversi con disinvoltura nel paese dove si parla la lingua. Questo livello consente di elaborare avvenimenti, esprimere preferenze ed opinioni personali."
      },
      B2: {
        LABEL: "Utente autonomo",
        DESCRIPTION:
          "In questo livello è possibile interagire con scioltezza e spontaneità con un nativo e si posseggono competenze di scrittura che consentono di elaborare testi semplici su argomenti di vario genere esprimendo anche il proprio punto di vista."
      },
      C1: {
        LABEL: "Utente avanzato",
        DESCRIPTION:
          "In questo livello si comprendono testi lunghi e complessi e si riescono a rielaborare. La lingua può essere usata e rielaborata per esprimere opinioni personali e concetti complessi, anche testi di tipo accademico."
      },
      C2: {
        LABEL: "Utente avanzato",
        DESCRIPTION:
          "Si riescono a comprendere facilmente qualsiasi cosa si legge o senta comprendendo le sfumature di significato anche sottili in situazioni complesse. Ci si riesce ad esprimere in modo scorrevole e preciso e e si riescono ad elaborare informazioni."
      }
    },
    PASSWORD_MISMATCH: "Le password non coincidono.",
    PASSWORD_WEAK: "La password deve essere lunga almeno 8 caratteri e contenere una lettera maiuscola, una minuscola, un numero ed un carattere speciale (! @ # $ % ^ & *)",
    MESSAGES: {
      NOTHING_TO_UPDATE: "Niente da aggiornare",
      ERROR_UPDATE_USER: "Errore nell'aggiornamento dell'utente.",
      SUCCESS_UPDATE_USER: "Utente aggiornato correttamente.",
      SUCCESS_UPDATE_USER_PASSWORD: "Password modificata correttamente.",
      ERROR_UPDATE_USER_PASSWORD: "Errore nella modifica della password.",
      RESIDENCE_PERMIT_UPLOAD_ERROR: "Errore nell'upload del permesso di soggiorno.",
      FISCAL_CODE_UPLOAD_ERROR: "Errore nel caricamento del codice fiscale.",
      ID_DOCUMENT_UPLOAD_ERROR: "Errore nel caricamento del documento di identità.",
      RESIGNATION_FILE_UPLOAD_ERROR: "Errore nell'upload del file delle dimissioni.",
      AVATAR_UPLOAD_ERROR: "Errore nell'aggiornamento dell'immagine del profilo.",
      UNAUTHORIZED: "Non sei autorizzato ad eseguire questa operazione.",
      AVATAR_UPLOAD_INFO: "Solo file JPG, JPEG o PNG di massimo 10MB. Le dimensioni consigliate sono 600x600.",
      EXPIRE_DATE_ERROR: "Data scadenza documento non valida.",
      BIRTH_DATE_ERROR: "Data di nascita non valida",
      SUCCESS_USER_DATA_INSERT: "Dati inseriti correttamente",
      ERROR_USER_DATA_INSERT: "Errore nell'inserimento dei dati, riprova fra qualche minuto. Se l'errore persiste contatta lo staff."
    },
    NO_DATA_TO_DISPLAY: "Nessun dato da mostrare",
    UPDATE_COSTS: "Aggiorna costi",
    SALARY_YEARLY_GROSS: "RAL",
    TOTAL_YEARLY: "Costo annuo",
    TOTAL_MONTH: "Costo mensile",
    PRESUMED_TOTAL_MONTHLY_COST: "Costo mensile presunto",
    EFFECTIVE_TOTAL_MONTHLY_COST: "Costo mensile effettivo",
    MONTHLY_GROSS_12: "RML (12)",
    MONTHLY_GROSS_13: "RML (13)",
    BONUS: "Bonus",
    NET_MONTHLY_12: "Netto mese (12)",
    NET_MONTHLY_13: "Netto mese (13)",
    TOTAL_DAILY: "Costo gg",
    SELECT_NOTICE_RESIGNATION: "Seleziona disponibilità",
    NOTICE_RESIGNATION: "Disponibilità",
    STRUCTURE_PERCENTAGE: "Struttura %",
    CONTRACT_DATA: "Dettagli contratto",
    GENERATE_BRANDED_CV: "Genera CV aziendale (anonimo)",
    GENERATE_BRANDED_CV_WITH_DATA: "Genera CV aziendale (con dati)",
    NUMBER: "Numero",
    NUMBER_EMPOLYEE: "Numero dipendenti",
    NUMBER_USERS: "Numero utenti",
    REQUEST_MASTERDATA: "Richiesta dati anagrafici",
    REQUEST_SIGN_CONTRACT: "Invia contratto da firmare",
    THANKYOU_FOR_DOCUMENTS: "Grazie per aver caricato i documenti richiesti.",
    THANKYOU_FOR_CONTRACT_SIGNED: "Grazie per aver caricato il contratto firmato.",
    THANKYOU_FOR_DATA: "Grazie per aver inviato i dati richiesti.",
    WE_WILL_WRITE_TO_YOU_1: "Ti ricontatteremo noi al più presto.",
    WE_WILL_WRITE_TO_YOU_2: "Nel frattempo, benvenuto a bordo!",
    EMPLOYEE_COSTS: "Costi contratto",
    PROPOSAL: "Proposta",
    SALARY_MONTH_12: "Netto mensile (no 13ª)",
    SALARY_MONTH_13: "Netto mensile (sì 13ª)",
    TOTAL_SALARY_MONTH_13: "Netto mensile (si 13ª) + bonus",
    TOTAL_SALARY_DAILY: "Totale costo giornaliero",
    COST_DAILY: "Costo giornaliero",
    MINIMUM_RAL_FOR_LEVEL: "RAL minima per livello",
    MAXIMUM_RAL_FOR_LEVEL: "RAL massima per livello",
    RAL_FOR_LEVEL: "RAL per il livello",
    IS_APPRENDISTATO: "Apprendistato",
    CLASSIFICATION: "Inquadramento",
    UPLOAD_CONTRACT: "Carica contratto",
    NOTICE: "Preavviso",
    NOTICE_5_YEARS: "Preavviso meno di 5 anni",
    NOTICE_5_TO_10_YEARS: "Preavviso 5-10 anni",
    NOTICE_10_YEARS: "Preavviso oltre 10 anni",
    DOWNLOAD_TEMPLATE_FILE_FROM_HERE: "Se hai bisogno del template",
    DOWNLOAD_IT_HERE: "scaricalo qui",
    TICKET_TOTAL_MONTH: "Totale in ticket per mese",
    TUTOR: "Tutor",
    ADD_LANGUAGE: "Aggiungi lingua",
    ADD_NOTE: "Aggiungi nota",
    EDIT_NOTE: "Modifica nota",
    EDIT_NAME: "Modifica nome",
    ADD_SKILL: "Aggiungi skill",
    ADD_GROUP: "Aggiungi gruppo",
    TEXT_VIA_MAIL: "Mandagli una email",
    SOURCES: "Fonti",
    SOURCE: "Fonte",
    NOTES: "Note",
    LABEL_ADD_NOTE: "Inserisci qui varie ed eventuali",
    DESIRED_CONTRACT: "Desiderata",
    LAST_UPDATE_DATE: "Aggiornato il",
    ALL_GROUPS: "Tutti gruppi",
    ALL_SKILLS: "Tutte le skill",
    ALL_FIGURES: "Tutte le figure",
    ALL_RECRUITERS: "Tutte le recruiter",
    RECRUITER: "Recruiter",
    ALL_CLIENT: "Tutti i clienti",
    ALL_STATUS: "Tutti gli stati",
    CERTIFICATE: "Certificazione",
    TECNICAL_CERTIFICATES: "Certificazioni tecniche",
    DOWNLOAD_CANDIDATE_CURRICULUM: "Scarica curriculum candidato",
    VIEW_CANDIDATE_CURRICULUM: "Guarda curriculum candidato",
    ID: "ID",
    ORDER: "Ordine",
    DEAL_ORDER: "Commessa",
    ENABLED: "Abilitata",
    DISABLED: "Disabilitata",
    DISABLED_SINGLE: "Disabilita",
    DISABLE_BARGAINING: "Disabilita contrattazione",
    GROUP_MEMBERS: "Componenti del gruppo",
    CODE: "Codice",
    TYPE_ABSENCE: "Tipo di assenza",
    ABSENCE_REQUIRE_NOTE: "Il tipo di assenza richiede una nota?",
    ABSENCE_REQUIRE_FILE: "Il tipo di assenza richiede un file allegato?",
    STATUS: {
      PENDING: "In coda",
      ERROR: "Errore",
      COMPLETED: "Completato",
      PROCESSING: "Invio in corso",
      SAVED: "Salvato",
      NOT_SAVED: "non salvato",
      IN_PROGRESS: "In lavorazione",
      TODO: "Da fare",
      STATUS: "Stato",
      SENDED: "Inviato",
      GENERATED: "Generato"
    },
    TITLE_COMMUNICATION: "Titolo comunicazione",
    CATEGORY_COMMUNICATION: "Categoria comunicazione",
    SEND_EMPOLYEE_COMMUNICATION: "Invia ai dipendenti",
    SEND_GROUP_COMMUNICATION: "Invia al gruppo",
    SEND_DATE: "Data d'invio",
    MESSAGGE: "Messaggio",
    SHOW_ALL: "Mostra tutti",
    SHOW_LESS: "Mostra meno",
    SEND_COMMUNICATION: "Invia comunicazione",
    INSERT_AT_LEAST_FOUR_CARACTHER: "Inserisci almeno 4 caratteri",
    VIEW_CURRENT_CONTRACT: "Visualizza contratto attuale",
    VIEW_COMMISSION: "Visualizza commessa",
    REQUIRE: "Richiedi",
    NOTE: "Note",
    MEDICAL_CERTIFICATE_PROTOCOL: "Protocollo certificato medico",
    REQUIRE_NEW_HOLIDAY: "Richiedi ferie",
    REQUIRE_NEW_PERMISSION: "Richiedi permesso",
    REQUIRE_NEW_SICKNESS: "Richiedi malattia",
    TYPE_HOLIDAY: "Tipo di ferie",
    TYPE_PERMISSION: "Tipo di permesso",
    TYPE_SICKNESS: "Tipo di malattia",
    HOUR_FROM: "Dalle",
    HOUR_TO: "Alle",
    TO_APPROVED: "Da approvare",
    NOT_APPROVED_PLURAL_MALE: "Non approvati",
    APPROVED_MALE_PLURAL: "Approvati",
    APPROVED_FEMALE_PLURAL: "Approvate",
    NOT_APPROVED_PLURAL: "Non approvate",
    APPROVED_FEMALE_SINGULAR: "Approvata",
    NOT_APPROVED_SINGULAR: "Non approvata",
    APPROVED_PENDING: "Da approvare",
    ABSENCES_REQUESTED_LIST: "Elenco richieste ferie, permessi e malattie",
    APPROVE: "Approva",
    UPDATE_APPROVEMENT: "Aggiorna approvazione",
    REJECT: "Rifiuta",
    REJECT_PLURAL: "Rifiutate",
    REJECT_MALE_PLURAL: "Rifiuti",
    VIEW: "Visualizza",
    ABSENCE: "Assenza",
    FILE: "File",
    PENDING: "Pending",
    DELETED: "Eliminata",
    DELETED_PLURAL: "Eliminate",
    AUTOMATIC_NOTIFICATION: "Notifica automatica",
    VIEW_OTHER_NOTIFICATIONS: "Altre notifiche",
    NOTIFICATION_SENDED_TO_USERS: "Notifica inviata agli utenti",
    NOTIFICATION_SENDED_TO_GROUPS: "Notifica inviata ai gruppi",
    AMOUNT: "Importo",
    REQUIRE_REFUND: "Richiedi rimborso",
    DAY_CAPITALIZE: "Giorno",
    REFUNDS: "Rimborsi",
    REFUNDED: "Rimborsati",
    REFUND: "Rimborso",
    NEW_ONE_NOTIFICATION: "nuova",
    NEW_MANY_NOTIFICATIONS: "nuove",
    NOT_ONE_SCHEDULED_NOTIFICATION: "Nessuna notifica programmata",
    INSERT_MOTIVATION_NOTE: "Inserisci nota per il dipendente",
    ABORTED: "Annullata",
    ABORTED_PLURAL: "Annullate",
    MOTIVATION: "Motivazione",
    MOTIVATION_NOTE: "Inserisci una motivazione",
    YOU_HAVENOT_NOTIFICATION: "Non hai notifiche non lette",
    NO_USERS_FOR_ONBOARDING: "Tutti i dipendenti hanno effettuato l'onboarding.",
    THIS_MONTH: "Questo mese",
    THIS_YEAR: "Quest'anno",
    WORK_REPORT_DATE: "Rapporto mensile di",
    WORKED_HOURS: "Ore lavorate",
    NOT_WORKED_HOURS: "Ore non lavorate",
    NO_RESULTS_FOR_SELECTED_PERIOD: "Nessun risultato per il periodo selezionato.",
    SEND_REPORT: "Invia rapportino",
    RESEND_REPORT: "Rinvia rapporto",
    FOR: "per",
    REJECTED: "Rifiutato",
    NOT_SENDED_PLURAL: "Non inviati",
    NOT_SENDED: "Non inviato",
    SENDED: "Inviato",
    SENDED_PLURAL: "Inviati",
    APPROVED_PLURAL_MALE: "Approvati",
    PAGE_NOT_AVAILABLE_FROM_MOBILE: "Questa funzionalità è disponibile solo da desktop.",
    VIEW_PROFILE: "Visualizza il profilo",
    SEND_EMAIL: "Invia email",
    SEND_WELCOME_EMAIL_MULTIPLE: "Invia email di benvenuto",
    SEND_REQUEST_DOCUMENT: "Invia richiesta documenti",
    SEND_CONTRACT: "Invia contratto da firmare",
    CALL: "Chiama",
    ALL_STATUSES: "Tutti gli stati",
    ALL_TYPES_ABSENCES: "Tutti i tipi di assenza",
    INSERTED_BY: "Inserito da",
    COMPANY: "Azienda",
    VAT_NUMBER: "Partita IVA",
    BUSINESS_NAME: "Ragione sociale",
    LOGO: "Logo",
    LABEL: "Label",
    STREET: "Indirizzo",
    ROAD: "Strada",
    ZIPCODE: "Codice Postale",
    RATE: "Tariffa",
    CUSTOMER: "Cliente",
    CUSTOMER_REFERENCE: "Referente cliente",
    CUSTOMER_COMMERCIAL: "Commerciale",
    SET_AS_REQUESTED_SKILL: "Skill obbligatoria",
    SET_AS_PRIORITY_REQUEST: "Richiesta con priorità alta",
    REQUEST_WITH_HIGH_PRIORITY: "Richiesta con priorità alta",
    ADD_NEW_CUSTOMER_REFERENCE: "Aggiungi nuovo referente",
    REQUIRED_SKILLS: "Skill obbligatorie",
    OPTIONAL_SKILLS: "Skill gradite",
    REQUIRED_LANGUAGES: "Lingue richieste",
    HIGH: "Alta",
    LOW: "Bassa",
    PRIORITY: "Priorità",
    COST: "Costo",
    INSERT_INTERVIEW_NOTE: "Inserisci data colloquio",
    DETAIL_SINGULAR: "Dettaglio",
    REQUEST_STEPS: {
      SUITABLE: "Idoneo",
      SUITABLE_PLURAL: "Idonei",
      PROPOSED: "Proposto",
      PROPOSED_PLURAL: "Proposti",
      FIRST_CALL: "1° Colloquio",
      SECOND_CALL: "2° Colloquio",
      KO: "Ko",
      OK: "Ok",
      BARGAINING: "Contrattazione"
    },
    NO_ONE: "Nessuna",
    THE_MASCULIN: "il",
    IN_DATE: "in data",
    FIELD_NOT_SPECIFIED: "Non specificato",
    FIELD_NOT_SPECIFIED_FEMALE: "Non specificata",
    REQUEST_PARAMETERS: {
      FIGURE_PARAM: "Parametro figura",
      SKILLS_REQUIRED_PARAM: "Parametro skill obbligatorie",
      SKILLS_OPTIONALS_PARAM: "Parametro skill gradite",
      CITY_PARAM: "Parametro città",
      SITE_PARAM: "Parametro modalità di lavoro",
      RATE_PARAM: "Parametro tariffa",
      CERTIFICATIONS_PARAM: "Parametro certificazioni",
      LANGUAGES_PARAM: "Parametro lingue",
      EDUCATION_TITLE_PARAM: "Parametro titolo di studi"
    },
    TIMELINE_STEPS_LABELS: {
      STEP_0_CANDIDATE: "Candidato inserito come idoneo",
      STEP_1_CANDIDATE: "Candidato proposto al cliente",
      STEP_2_CANDIDATE: "Primo colloquio",
      STEP_3_CANDIDATE: "Secondo colloquio",
      STEP_4_CANDIDATE: "Candidato rifiutato",
      STEP_5_CANDIDATE: "Candidato ha superato i colloqui",
      STEP_6_CANDIDATE: "Inizio fase di contrattazione",
      STEP_0_EMPLOYEE: "Dipendente inserito come idoneo",
      STEP_1_EMPLOYEE: "Dipendente proposto al cliente",
      STEP_4_EMPLOYEE: "Dipendente rifiutato",
      STEP_5_EMPLOYEE: "Dipendente ha superato i colloqui",
      STEP_2: "Primo colloquio",
      STEP_3: "Secondo colloquio",
      STEP_6: "Inizio fase di contrattazione"
    },
    DOCUMENTS_NUMBER: "Numero di documenti",
    INSERT_AS_A_CHILD: "E' figlio di una categoria esistente?",
    SELECT_PARENT: "Seleziona categoria genitore",
    TITLE_DOCUMENT: "Titolo documento",
    FOR_USER: "Per l'utente",
    CATEGORY_DOCUMENT: "Categoria documento",
    CREATE_DOCUMENT: "Crea un documento da zero?",
    PREVIEW: "Vedi anteprima",
    SEND_ALL_EMPLOYEE: "Invia a tutti i dipendenti",
    REQUIRE_SIGNATURE: "Richiede firma?",
    REQUIRE_ACCEPTION: "Richiede presa visione?",
    SEND_NOW: "Invia ora?",
    DOCUMENT: "documento",
    EDIT_DOCUMENT: "Modifica documento",
    EXPIRE_DATE: "Data di scadenza",
    DATE: "Data",
    STATUS_LABEL: "Stato",
    UPLOAD_SIGNED_DOCUMENT: "Carica documento firmato",
    SEND_SIGNED_DOCUMENT: "Invia documento firmato",
    REQUIRED_SIGNATURE: "Richiede firma",
    REQUIRED_ACCEPTION: "Richiede presa visione",
    DECLARE_ACKNOWLEDGE: "Dichiaro di aver letto il documento",
    SEARCH_DOCUMENT: "Cerca documento",
    SEND_DOCUMENT: "Invia documento",
    STATUS_SIGNATURE: "Stato firma",
    STATUS_ACCEPTION: "Stato presa visione",
    SIGNED: "Firmato",
    NOT_SIGNED: "Da firmare",
    NOT_REQUIRED_SIGNATURE: "Non richiede firma",
    VIEWED: "Visionato",
    NOT_VIEWED: "Da visionare",
    NOT_REQUIRED_VIEW: "Non richiede presa visione",
    WITHIN: "entro il",
    FIRSTNAME_EMERGENCY_CONTACT: "Nome contatto di emergenza",
    LASTNAME_EMERGENCY_CONTACT: "Cognome contatto di emergenza",
    NUMBER_EMERGENCY_CONTACT: "Numero di emergenza",
    NUMBER_ABSENCES_HOLIDAYS: "Numero giorno di ferie",
    NUMBER_ABSENCES_PERMISSIONS: "Numero giorni di permesso",
    NUMBER_ABSENCES_SICKNESS: "Numero giorni di malattia",
    ZIP_CODE: "Codice postale",
    START_CONTRACT_DATE: "Data inizio contratto",
    IBAN: "Iban",
    TIME_PROCESS_CREATE_DOCUMENT: "Per la creazione dei documenti saranno richiesti",
    SIGNATURE_TO_APPROVE: "Firma da approvare",
    LEGEND: "Legenda",
    SEND_STATUS: "Stato invio",
    CREATING: "Creazione in corso",
    ERROR_SEND: "errore invio",
    AFFINITY: "Affinità",
    RATE_REQUEST: "Tariffa della richiesta",
    START_BARGAINING: "Avvia contrattazione",
    START_BARGAINING_INSTRUCTION: "Seleziona una richiesta e scegli il candidato con cui avviare una contrattazione.",
    APPRENTICEABLE: "Apprendistabile",
    MASTERDATA_DOCUMENT: "Documenti anagrafici",
    CONTRACT_DOCUMENT: "Documenti contratto",
    VIEW_CONTRACT: "Visualizza contratto",
    VIEW_DOCUMENT: "Visualizza documento d'identità",
    VIEW_FILE_DOCUMENT: "Visualizza documento",
    VIEW_FISCAL_CODE_DOCUMENT: "Visualizza codice fiscale",
    VIEW_DATA: "Visualizza dati",
    MASTER_DATA: "Dati anagrafici",
    MASTER_DATA_AND_DOCUMENT: "Dati anagrafici e documenti di identità",
    VIEW_PERMIT_URL: "Visualizza permesso di soggiorno",
    RESEND_CONTRACT: "Rinvia contratto",
    PROFILE_PICTURE: "Immagine di profilo",
    EDIT_HOURS: "Modifica le ore per il giorno",
    SHOW_ONLY: "Mostra solo",
    NEW_NOTIFICATIONS: "Nuove notifiche",
    OLD_NOTIFICATIONS: "Vecchie notifiche",
    SET_NOTIFICATION_AS_READ: "Imposta come letta",
    SET_NOTIFICATIONS_AS_READ: "Imposta come lette",
    REQUEST: "Richiesta",
    HISTORICAL: "Storico",
    CANDIDATE_HAS_NO_REQUESTS: "Il candidato non è presente in nessuna richiesta.",
    VIEW_BARGAINING: "Visualizza contrattazione",
    VIEW_REQUEST: "Visualizza richiesta",
    AUTH: {
      RESET_PASSWORD: "Reimposta la password",
      CREATE_YOUR_PASSWORD: "Crea la tua password",
      CREATE_PASSWORD: "Crea password",
      BACK_TO_LOGIN: "Ritorna al login",
      CONFIRM_PASSWORD: "Conferma password",
      PASSWORD_IS_REQUIRED: "La password è obbligatoria",
      CREATE_PASSWORD_DISCLAIMER: "Crea la tua password ed entra per la prima volta nel mondo Nepta.",
      CHANGE_PASSWORD_DISCLAIMER: "La tua nuova password deve essere diversa dalla precedente."
    },
    CONFIGURATIONS: {
      CONFIGURATION: "Configurazione",
      CONFIGURATIONS: "Configurazioni",
      MANAGE_REPORT_UNLOCK_DAY: "Gestisci giorni per l'invio del rapportino",
      MANAGE_WORKDAY_WEEK: "Gestisci giorni lavorativi e festivi",
      SET_REPORT_UNLOCK_DAY: "Imposta giorni lavorativi per invio rapportino",
      EXPLICATION_UNLOCK_DAY: "Inserisci il valore numerico dei giorni lavorativi precedenti all'ultimo giorno del mese, in quel range tra la fine del mese ed il valore impostato sarà possibile inviare il rapportino.",
      SET_MARGIN_REQUEST: "Imposta margine richieste",
      SET_MARGIN_FOR_REQUEST: "Imposta margine di guadagno per le richieste",
      SET_MARGIN_PROFIT: "Imposta margine fatturato effettivo commesse.",
      SET_MARGIN_FOR_PROFIT: "Imposta margine di fatturato effettivo per le commesse",
      SET_MARGIN_COST: "Imposta margine costi commesse.",
      SET_MARGIN_FOR_COST: "Imposta margine dei costi effettivi per le commesse",
      SET_INPUT_DATE_RETROACTIVE: "Imposta input date retroattivi",
      SET_EVIDENCE_COST_MESSAGE: "Seleziona il costo associato ai dipendenti fermi",
      SET_INPUT_DATE_RETROACTIVE_MESSAGE: "Da qui puoi attivare la possibilità di selezionare date antecedenti ad oggi nei form delle commesse, ordini e offerte.",
      EDIT_PARAGRAPHS_DEALS: "Modifica template paragrafi offerte",
      EDIT_DESCRIPTION_JOB_POSITIONS: "Modifica descrizioni predefinite",
      EDIT_DESCRIPTION_JOB_POSITIONS_MESSAGE: "Modifica la descrizione di apertura e la descrizione di chiusura predefinite delle posizioni lavorative",
      SET_EVIDENCE_COST: "Seleziona un costo stand-by"
    },
    SEND_WELCOME_EMAIL: "Manda email di benvenuto",
    MAKE_PUBLIC_MASCULIN: "Rendi pubblico all'interno della piattaforma",
    MAKE_PUBLIC_FEMALE: "Rendi pubblica all'interno della piattaforma",
    HOLIDAYS_AND_PERMISSIONS: "Ferie e permessi",
    HOLIDAYS_NOT_TAKEN: "Ferie non godute",
    PERMISSION_NOT_TAKEN: "Permessi non goduti",
    VALID_SINCE_DATE: "Data di decorrenza",
    NO_NOTES: "Nessuna nota.",
    UPDATE_RESIDUAL_ABSENCES: "Aggiorna assenze residue",
    ERROR_FISCAL_CODE_NUMBERS: "Errore numero codici fiscali: Controlla il dipendente con codice fiscale ",
    ERROR_ABSENCES_NUMBERS: "Errore numero tipo di assenze: Controlla il dipendente con codice fiscale",
    COMPLETE_NAME: "Nome",
    TYPE: "Tipo",
    QUANTITY: "Quantità",
    UPDATE_DATE: "Aggiornato al",
    SELECT_FILES: "Scegli files",
    UPLOAD_QUEUE: "Coda di upload",
    SELECTED_FILE: "File selezionati",
    REMOVE_ALL: "Rimuovi tutti",
    QUEUE_PROGRESS: "Progresso coda",
    UPLOAD_ALL: "Carica tutti",
    DISMISSAL: "Licenziamento",
    RESIGNATION: "Dimissioni",
    IS_LAST: "Inserito negli ultimi 30 giorni",
    IS_START: "Deve iniziare",
    IS_ENDING: "Contratto in scadenza",
    IS_FIRED: "Ha presentato le dimissioni",
    SELECT_FILE: "Seleziona file",
    DROP_FILE_TO_DOWNLOAD: "Trascina il file qui per caricarlo",
    PROGRES: "Progressi",
    SIZE: "Dimensioni",
    QUEUE_LENGTH: "Lunghezza coda",
    CANCEL_ALL: "Cancella tutti",
    MULTIPLE: "Multipli",
    SINGLE: "Singoli",
    RESIDUAL_HOLIDAYS: "Ferie residue",
    RESIDUAL_PERMISSIONS: "Permessi residui",
    NOT_UPDATE: "Non aggiornato",
    OWNER: "Proprietario",
    ENTER_MULTI_FILE: "Inserisci uno o piu file",
    CLOSE_BARGAINING: "Chiudi contrattazione",
    UNLOCK_WORKDAY_REPORT_LABEL: "Potrai inviare il tuo rapportino a partire dal",
    RESEND_REPORT_REJECTED: "Il tuo rapportino è stato rifiutato rinvialo prima della fine del mese.",
    AVAILABLE_FROM: "Disponibile dal",
    REPORT_AVAILABLE_FROM: "Potrai inviare il rapportino dal",
    UPLOAD_ATTACHMENTS: "Carica allegati",
    UPLOADED_DOCUMENTS: "Documenti caricati",
    REVOKE_RESIGNATION_OR_DIMISSIONS: "Revoca dimissioni/licenziamento",
    ERROR_UPLOAD_FILES: "Errore nel caricamento dei file.",
    SUCCESS_UPLOAD_FILES: "File caricati con successo.",
    ERROR_DELETE_FILE: "Errore nella cancellazione del file.",
    FILE_SIZE_LIMIT: "Dimensioni file",
    INVALID_EMAIL: "Email non valida",
    INVALID_PASSWORD: "Password errata",
    PASSWORD: "Password",
    INVALID_EMAIL_ADDRESS: "Indirizzo email errato",
    PLATFORM_IN_MAINTENANCE: "Piattaforma attualmente in manutenzione. Riprova fra qualche minuto.",
    ERROR_CONNECTION: "Errore di connessione",
    NO_INSERTED_NOTE: "Nessuna nota inserita",
    AUTHOR_NAME: "Nome autore",
    SELECT_ALL: "Seleziona tutte",
    DESELECT_ALL: "Deseleziona tutte",
    SELECT_ALL_MALE: "Seleziona tutti",
    DESELECT_ALL_MALE: "Deseleziona tutti",
    INSERT_IN_BLACK_LIST: "Inserisci nella black list",
    CANDIDATE_BLACKLISTED: "In blacklist",
    GENERIC_ERROR: "Errore, riprova tra qualche minuto o contatta lo staff",
    SOME_DATA_ARE_NOT_VALID: "Alcuni dati non sono validi controlla: ",
    DESIRED_SITE: "Modalità di lavoro desiderata",
    CLICK_HERE_COMPRESS_FILE: "Clicca qui per comprimere il file",
    CERTIFICATION_TO_APPROVE: "Certificazioni da aggiungere",
    ASSIGN_ASSET: "Assegna asset",
    DETAILS: "Dettagli",
    PREVIEW_CONTRACT: "Anteprima",
    LOGOUT: "Esci",
    ACTIVATED: "Attivata",
    IS_CURRENT_EXPERIENCE: "Esperienza in corso?",
    SKILLS_TO_APPROVE: "Skill suggerite",
    MAX_FILE: "Il file deve essere minore di 10 mb",
    SKILL_FROM_EXPERIENCE: "Skill proveniente da esperienze",
    SITE: "Modalità di lavoro",
    PARAMETER: "Parametro",
    ASSIGNED_POINTS: "Punti assegnati",
    PARAMETER_MATCHMAKING: "Parametri matchmaking",
    LOADING_DATA: "Caricamento dati in corso",
    ASSOCIATE: "Associa",
    DISSOCIATE: "Dissocia",
    INTERNAL_SERIAL: "Seriale interno",
    PRODUCT_SERIAL_NUMBER: "Seriale prodotto",
    LOCATION: "Location",
    LOG: "Evento",
    LOGS: "Eventi",
    EMPLOYEE: " Dipendente",
    MAINTENANCE: "Manutenzione",
    IN_MAINTENANCE: "In manutenzione",
    ASSIGN_MALE: "Assegnato",
    NO_EMPLOYEE: "Nessun dipendente",
    ATTACHMENTS: "Allegati",
    INTERNAL: "Interna",
    ESTERNAL: "Esterna",
    OLD_EMPLOYEES: "Vecchi dipendenti",
    ASSIGNED_DATE: "Data d'assegnazione",
    NOT_ASSIGNED: "Non assegnato",
    OLD_EMPLOYEE: "Vecchi utilizzatori",
    RENTAL: "Noleggio",
    END_DATE_CONTRACT: "Data fine contratto",
    TO_END_DATE_CONTRACT: "A data fine contratto",
    START_DATE_CONTRACT: "Data inizio contratto",
    FROM_START_DATE_CONTRACT: "Da data inizio contratto",
    EMAIL: "Email",
    OFFICE_SITE: "Sede",
    EXTRA_HOURS: "Ore extra",
    UPDATE: "Aggiorna",
    WORKDAY_REPORT_OF: "Rapportino mensile di ",
    NOW_SUGGEST_SAVE_WORKDAY_REPORT: "Intanto se hai alcune modifiche da apportare ti consigliamo di modificare e salvare.",
    PARAMETER_MATCHMAKING_FOR: "Parametri matchmaking per",
    REQUESTED_PARAMETERS: "Parametri richiesti",
    PLATFORM_MANAGEMENT: "Gestione piattaforma",
    LISTS: "Liste",
    ADD_ABSENCE_EMPLOYEE: "Aggiungi assenza dipendente",
    VALID_FISCAL_CODES_FOR_ABSENCES_NUMBER: "Assenze aggiornate per [NUMERO] dipendenti",
    INVALID_FISCAL_CODES_FOR_ABSENCE_NUMBER: "Assenze non aggiornate per [NUMERO] dipendenti perché non trovati",
    WORKING: "Lavorativo",
    HOLIDAY: "Festivo",
    NUMBER_OF_DAY: "Numero di giorni",
    COSTS: "Costi",
    REQUEST_MARGIN: "Margine richiesta",
    PROFIT_MARGIN: "Margine fatturato effettivo",
    COST_MARGIN: "Margine costo effettivo",
    TAKEN_CHARGE: "Preso in carico",
    DETAIL_SUPPORT_REQUEST: "Dettaglio richiesta di supporto",
    STAFF_RESPONSE: "Risposta dello staff",
    TAKE_CHARGE: "Prendi in carico",
    CLOSE_SUPPORT_REQUEST: "Rispondi e chiudi",
    UPLOAD_ATTACHMENT: "Carica allegato",
    RESPONSE: "Risposta",
    OPERATOR: "Operatore",
    BRAND_MODEL: "Marca/Modello",
    CHARACTERISTICS: "Caratteristiche",
    NOW_YOU_CAN_SEND_REPORT: "Da oggi puoi inviare il rapportino.",
    NOW_YOU_CAN_SEND_YOUR_REPORT: "Da oggi puoi inviare il tuo rapportino",
    SUBMIT_REPORT_BEFORE_DEADLINE: "Invia il tuo rapportino prima della fine del mese",
    YOU_SENDED_REPORT: "Hai inviato il tuo rapportino",
    NOT_ONE_SUPPORT_REQUEST: "Nessuna richiesta di supporto",
    NOT_ONE_ABSENCE_REQUEST: "Nessuna richiesta di assenza da processare.",
    NOT_ONE_REFUND: "Nessun rimborso richiesto",
    MINE_REFUND: "I miei rimborsi",
    FROM_PERSON: "Da",
    STATUS_STEP_SINGULAR: {
      STEP_0: "Idoneo",
      STEP_1: "Proposto",
      STEP_2: "Primo colloquio",
      STEP_3: "Secondo colloquio",
      STEP_4: "Ko",
      STEP_5: "Ok",
      STEP_6: "Contrattazione"
    },
    ON_DATE: "In data",
    ASSIGN_EMAIL: "Associa email aziendale",
    SET_A_MAINTENANCE: "Programma una manutenzione",
    THERE_IS_A_MAINTENANCE: "È stata programmata una manutenzione",
    UNTIL_DATE: "Fino al",
    TOTAL_EXTRA_KM: "Tot. km",
    TOTAL_EXTRA_KILOMETER: "Totale chilometri",
    TOTAL_EXTRA_PAYROLL: "Tot. b.paga",
    TOTAL_PAYROLL: "Totale busta paga",
    REFUND_KM: "Rimb. km",
    REFUND_KILOMETER: "Rimborso chilometrico",
    REFUND_PAYROLL: "Rimb. in busta paga",
    EXTRAORDINARY: "Straordinario",
    ONBOARDING: "Onboarding",
    COMPLETE_ONBOARDIONG: "Onboarding completato",
    CONTRACTS_HISTORY: "Archivio modifiche contratto",
    DOCUMENTS_ARCHIVE: "Archivio documenti",
    NO_FUTURE_EMPLOYEES: "Non ci sono dipendenti futuri",
    NO_DOCUMENTS_TO_PROCESS: "Non ci sono documenti che richiedono la tua attenzione.",
    NO_RESIGNED_EMPLOYEES: "Non ci sono dipendenti dimissionari",
    TOTAL_NET_MONTHLY_13: "Totale netto mensile con 13a",
    CONTRACT_NAME: "Contratto",
    EDITED_IN_DATE: "Modificato in data",
    REMOVED_DATE: "Data rimossa",
    LAST_BARGAINING: "Ultime contrattazioni",
    NO_REQUEST: "Non è presente nessuna richiesta",
    SAVED_PLURAL: "Salvati",
    SELECT_ROLE: "Seleziona ruolo",
    CLOSE_REQUEST: "Chiudi richiesta",
    WILL_BE_CALCULATE_DINAMICALLY: "Saranno calcolati dinamicamente",
    WILL_BE_CALCULATE_DINAMICALLY_CONTINUE: "giorni lavorativi a partire dalla fine del mese.",
    OPENED_FEMALE: "Aperta",
    CLOSED_FEMALE: "Chiusa",
    CLOSING: "In chiusura",
    ALL_STATE: "Tutti gli stati",
    CLOSED_REQUEST: "Richiesta chiusa",
    URGENT: "Urgente",
    URGENTS: "Urgenti",
    IMPORTANT: "Importante",
    IMPORTANTS: "Importanti",
    COMPLETEDS_FEMALE: "Completate",
    MEDIUM_SINGULAR_FEMALE: "Media",
    LOW_PRIORITY: "Bassa priorità",
    MEDIUM_PRIORITY: "Media priorità",
    HIGH_PRIORITY: "Alta priorità",
    HAS_ATTACHMENTS: "Ha allegati",
    TITLE: "Titolo",
    GROUP: "Gruppo",
    ASSIGNED_FROM_ME: "Assegnati da me",
    ASSIGNED_TO_ME: "Assegnati a me",
    NO_ATTACHMENTS: "Nessun allegato",
    NO_COMMENTS: "Nessun commento",
    ALL_LIST_TODO: "Lista di tutte le task",
    NO_GROUP: "Nessun gruppo",
    NO_ROLE: "Nessun ruolo",
    GROUPS: "Gruppi",
    SELECT_EMPLOYEES: "Seleziona dipendenti",
    SELECT_EMPLOYEE: "Seleziona dipendente",
    SELECT_COLLEAGUES: "Seleziona colleghi",
    SELECT_GROUP: "Seleziona gruppo",
    ASSIGN_TO: "Assegno a",
    ASSIGNED: "Assegnato",
    CREATED_AT_FEMALE: "Creata il",
    TYPE_A_COMMENT: "Digita qui il commento",
    SEND_COMMENT: "Invia commento",
    INSERT_DATE: "Inserito il",
    COMMENTS: "Commenti",
    IN_PROGRESS_FROM: "In lavorazione da ",
    COMPLETED_FROM: "Completato da ",
    HAS_CHANGE_STATUS: "ha cambiato lo stato in",
    PROGRESS: "Lavorazione",
    TYPE_NATIONALITY: "Tipo di nazionalità",
    ITALIAN: "Italiana",
    REQUEST_RESET_PASSWORD: "Richiesta reimpostazione password",
    MESSAGE_RESET_PASSWORD: "Inserisci la tua email, provvederemo ad inviarti un link per reimpostare la tua password.",
    SIGN_IN: "Accedi",
    PASSWORD_IS_REQUIRED: "Password obbligatoria",
    FORGOTTEN_PASSWORD: "Password dimenticata?",
    EMAIL_REQUIRED: "Email richiesta",
    EMAIL_NOT_VALID: "Email non valida",
    WELCOME: "Benvenuto",
    LOGIN_MESSAGE_WELCOME: "Inserisci i tuoi dati ed entra nell'ecosistema Nepta.",
    ASSIGN_CAPABILITY: "Assegna permesso",
    LAST_CANDIDATE: "Ultimi candidati",
    REOPEN_REQUEST: "Riapri richiesta",
    GENERATE_PDF: "Scarica pdf",
    ARCHIVE_REPORTS: "Archivio rapportini",
    ADD_EXTRA_HOUR: "Aggiungi ore extra",
    EXTRA: "Extra",
    WORKING_HOURS: "Ore lavorative",
    CREATE_TEMPLATE_FROM_SCRATCH: "Vuoi creare il template da zero?",
    AVAILABLE_IN_ONBOARDING: "Disponibile al onboarding?",
    VIEW_TEMPLATE: "Vedi template",
    BANK_DATA: "Dati bancari",
    ACKNOWlLEDGMENT_DICHIARATION: "Dichiaro di aver preso visione di tutti i documenti",
    VIEW_FILE: "Visualizza file",
    VIEW_ALL: "Visualizza tutti",
    VIEW_ALL_FEMALE: "Visualizza tutte",
    ALL_RIGHTS_RESERVED: "Tutti i diritti riservati",
    SIGNATURE: "Firma",
    REQUIRED_FEMALE: "Richiesta",
    NOT_REQUIRED_FEMALE: "Non richiesta",
    VIEW_DOCUMENTS: "Visualizza documenti",
    AVAILABLE_ONBOARDING_DOCUMENT: "Disponibile nel onboarding",
    NOT_AVAILABLE_ONBOARDING_DOCUMENT: "Non disponibile nel onboarding",
    BADGE_NUMBER: "Matricola",
    COPY: "Copia",
    CORPORATE_SIGNATURE: "Firma aziendale",
    CORPORATE_EMAIL_SIGNATURE: "Firma email aziendale",
    COPY_CORPORATE_EMAIL_SIGNATURE: "Copia firma email aziendale",
    UPLOAD_PAYROLL: "Carica buste paga",
    PAYROLL_TO_UPLOAD_LIST: "Lista file buste paga",
    NO_FILES_SELECTED: "Nessuna busta paga caricata.",
    LIST_PAYROLL_NOT_FOUNDED: "Lista buste paga non trovate",
    FISCALCODES_NOT_MATCHED: "Non sono stati trovati i codici fiscali per queste buste paga:",
    EMAIL_NOT_SENDED_FOR_THESE_USERS: "Email di benvenuto non inviate per i seguenti dipendenti:",
    PAYROLL_UPLOAD_ERRORS_TITLE: "Errore/i nell'invio delle buste paga.",
    PAYROLL_UPLOAD_ERRORS_DESCRIPTION: "Ci sono stati uno o più errori durante l'invio delle buste paga:",
    EMPLOYEE_NOT_FOUND: "Dipendente non trovato.",
    FUTURE_EMPLOYEE_NOT_FOUND: "Futuro dipendente non trovato.",
    FILENAME_FORMAT_INVALID: "Nome file non corretto.",
    ERROR_CREATING_PAYROLL: "Errore nella creazione della busta paga.",
    ERROR_UPLOADING_PAYROLL: "Errore nel caricamento della busta paga.",
    ALL_ROLES: "Tutti i ruoli",
    NO_ROLES: "Nessun ruolo",
    RESIGNATIONS: "Dimissioni",
    DOCUMENT_VALID_UNTIL: "documento scadenza",
    DOCUMENT_RESIDENCE_PERMIT_NUMBER: "Numero permesso di soggiorno",
    DOCUMENT_RESIDENCE_PERMIT_VALID_UNTIL: "Scadenza permesso di soggiorno",
    VIEW_EMPTY_FIELDS: "Visualizza i campi mancanti",
    SELECT_STATUS: "Seleziona uno stato",
    SELECT_PRIORITY: "Seleziona una priorità",
    FILTER_STATUS: "Filtra per stato",
    FILTER_PRIORITY: "Filtra per priorità",
    YOU_CANNOT_CREATE_REFERENT: "Non hai i permessi per creare nuovi referenti",
    YOU_CANNOT_CREATE_OFFICE_SITE: "Non hai i permessi per creare nuove sedi",
    CREATE_A_SITE_OFFICE: "Per poter creare un referente devi prima aggiungere almeno una sede.",
    EDIT_SITE: "Modifica sede",
    ADD_REFERENT: "Aggiungi referente",
    EDIT_REFERENT: "Modifica referente",
    RECIEVED_PLURAL: "Ricevuti",
    RESIDENCE_COMPLETE_ADDRESS: "Indirizzo di residenza completo",
    CONTRACT_START_DATE: "Data inizio contratto",
    CONTRACT_END_DATE: "Data fine contratto",
    CONTRACT_LEVEL: "Livello contratto",
    CONTRACT_CONTRACT_NAME: "Tipo di contratto",
    ASSIGN_TO_MY_SELF: "Assegna a me stesso",
    ADD_COLLABORATOR: "Aggiungi collaboratore",
    EDIT_COLLABORATOR: "Modifica collaboratore",
    DAILY_COST_PRESUMED: "Costo presunto giornaliero",
    UNIQUE_CODE: "Codice univoco",
    PEC: "PEC",
    RECIPIENT_PEC: "PEC destinatario",
    BILLING_ADDRESS: "Indirizzo di fatturazione",
    FILE_LIST: "Lista file",
    NO_ONE_FILE_UPLOADED: "Nessun file inserito",
    INTERN: "Stagista",
    COLLABORATORS_LIST: "Lista collaboratori",
    FILE_TO_UPLOAD: "File da caricare",
    DISABLE_USER: "Disabilita utente",
    ENABLE_USER: "Abilita utente",
    TRANSFORM_TO_COLLABORATOR: "trasformazione a collaboratore",
    TRANSFORM_TO_EMPLOYEE: "Avvia trasformazione a dipendente",
    REFUSE_MOTIVATION: "Rifiutato con motivazione",
    STATUS_DOCUMENTS: "Stato documenti",
    STATUS_CONTRACT: "Stato contratto",
    STATUS_TRANSFORMATION: "Stato trasformazione",
    START_TRANSFORMATION: "Avvia trasformazione",
    CREATE_TRANSFORMATION: "Crea trasformazione",
    START_TRANSFORMATION_INSTRUCTION: "Seleziona un collaboratore con cui avviare una trasformazione.",
    DETAIL_COLLABORATOR: "Dettaglio collaboratore",
    EDIT_TRANSFORMATION: "Modifica trasformazione",
    CLOSE_TRANSFORMATION: "Chiudi trasformazione",
    TRANSFORMATION: "Trasformazione",
    OCCASIONAL_PERFORMANCE: "Prestazione occasionale",
    COLLABORATOR: "Collaboratore",
    DOWNLOAD: "Download",
    INSERT_DESCRIPTION_TUTORIAL: "Inserisci una descrizione dettagliata del tutorial.",
    CONFIRM_DELETE_TUTORIAL_VIDEO: "Sei sicuro di voler eliminare questo video?",
    VIDEO_FILE_MP4: "Video MP4",
    VIDEO_FILE_OGG: "Video OGG",
    VIDEO_FILE_WEBM: "Video WEBM",
    PLAY_VIDEO: "Riproduci video",
    OPEN_VIDEO: "Apri video",
    DONT_KNOW_HOW_TO_DO: "Non sai come fare?",
    SHOW_TUTORIAL: "Visualizza tutorial",
    TUTORIAL_UPLOADED: "Tutorial caricati",
    FILE_DIMISSIONS: "File dimissioni",
    PROCESSED_ITEMS: "Elementi processati",
    CANDIDATE: "Candidato",
    STATUS_DOCUMENT: "Stato documenti",
    CONTRACT_AND_LEVEL: "Contratto-Livello",
    TICKET: "Ticket",
    TELEPHONE: "Telefono",
    SEARCH_EMPLOYEE: "Cerca dipendente",
    ACCEPT: "Accetta",
    INSERT_BUTTON: "Inserisci",
    TITLE_POSITION: "Titolo posizione",
    STATUS_SELECT: "Seleziona lo stato",
    LAST_EDIT: "Ultima modifica",
    SEARCH_NOTIFICATION: "Cerca notifica",
    LINK: "Link",
    THE_SYSTEM: "Il sistema",
    LAST_UPLOAD: "Ultimo inserimento",
    BONUS_EXTRA: "Bonus extra",
    GENERATE_DOCUMENT: "Genera",
    ADD_BONUS_EXTRA: "Aggiungi bonus extra",
    EDIT_BONUS_EXTRA: "Modifica bonus extra",
    ADD_BONUS: "Aggiungi bonus",
    EDIT_BONUS: "Modifica bonus",
    DISTANCE_FROM_US: "Distanza km dalla sede operativa A/R",
    KM_EXPLICATION_CALCULATE: "In caso il valore sia 0, la distanza verrà calcolata in modo automatico",
    DEAL: "Offerta",
    DEALS_LIST: "Lista offerte",
    BILLING_FREQUENCY: "Frequenza di fatturazione",
    PAYMENT_MEASURE_UNIT: "Unità di misura",
    INVOICE_TYPE: "Tipo di fattura",
    CAUSAL: "Causale",
    BILLING_FREQUENCY_LABEL: {
      MONTHLY: "Mensile",
      BIMONTHLY: "Bimestrale",
      THREE_MONTHLY: "Trimestrale",
      QUARTERLY: "Quadrimestrale",
      HALF_YEARLY: "Semestrale",
      YEARLY: "Annuale"
    },
    TOTAL_SINGULAR: "Totale",
    TIME_MATERIAL: "Time Material",
    TASK: "Task",
    SELECT_TYPE_DEAL: "Seleziona tipo di offerta",
    DEAL_DOCUMENT: "Documento offerta",
    DETAIL_OFFER_TASK: "Dettaglio offerta task",
    DETAIL_OFFER_TIME_MATERIAL: "Dettaglio offerta Time Material",
    SUPPLY_OBJCET: "Oggetto della fornitura",
    SUPPLY_DESCRIPTION: "Descrizione della fornitura",
    ECONOMIC_OFFER: "Offerta economica",
    JOB_SITE_AND_TIMETABLES: "Sede di lavoro e orari",
    LEGAL_OBLIGATIONS: "Obblighi di legge",
    PRIVACY: "Privacy",
    FACTURATION_MODE: "Modalità di fatturazione",
    PAYAMENT_TERMS: "Termini di pagamento",
    VALID_OFFFER: "Validità dell' offerta",
    DAILY_RATE: "Tariffa giornaliera",
    ADD_DAILY_RATE: "Aggiungi tariffa gg",
    ADD_EMPLOYEE: "Aggiungi dipendente",
    ABBREVATION_DAYS: "gg",
    TYPOLOGY: "Tipologia",
    ACTIVITY: "Attività",
    ADD_OR_REMOVE_A_ROW: "Aggiungi o rimuovi una riga",
    ROW: "Riga",
    REGENERATE_DOCUMENT: "Rigenera documento",
    CUSTOMER_INFORMATION: "Informazioni cliente",
    DEAL_INFORMATION: "Informazioni offerta",
    DISCOUNTED_AMOUNT: "Importo scontato",
    TOTAL_DISCOUNTED_AMOUNT: "Totale scontato",
    TOTAL_AMOUNT: "Importo totale",
    DEAL_ORDERS: "Commesse",
    OBJECT: "Oggetto",
    PARAGRAPH: "Paragrafo",
    EDIT_AND_GENERATE: "Modifica e genera",
    UPLOAD: "Upload",
    UPLOAD_DEAL_MESSAGE: "Caricando un file sovrascrivi il file esistente.",
    MATCH_REQUEST: "Richieste compatibili",
    LOAD_CANDIDATE_MATCHED_REQUESTS: "Visualizza tutte le richieste compatibili con questo candidato.",
    NO_MATCHED_REQUESTS: "Nessuna richiesta compatibile con questo candidato.",
    LOAD: "Carica",
    SHORTLINK: "Short link",
    DESTINATION: "Destinazione",
    IP: "Indirizzo IP",
    USER_AGENT: "Informazioni dispositivo",
    HASH: " Hash",
    VIEW_TABLE: "Vista tabella",
    VIEW_FOLDER: "Vista cartella",
    NOT_FILES_FOUNDED: "Nessun file trovato",
    MIN_MAX_VAT_NUMBER: "Minimo 9, massimo 12 caratteri alfanumerici",
    MIN: "Minimo",
    MAX: "Massimo",
    CHARACTERS: "caratteri",
    CAPACITY: "Capienza",
    RESIDUE: "Residuo",
    ORDER_DATE: "Data ordine",
    ORDER_NUMBER: "Numero ordine (cliente)",
    DETAIL_ROUND: "Dettaglio round",
    DETAIL_COMMISSION: "Dettaglio commessa",
    PROTOCOL: "Protocollo",
    ADD_ROUND: "Aggiungi round",
    DELETE_ROUND: "Rimuovi round",
    OPEN_DETAIL: "Apri dettaglio",
    OPEN_DETAIL_EMPLOYEE: "Apri dettaglio dipendenti",
    CLOSE_DETAIL_EMPLOYEE: "Chiudi dettaglio dipendenti",
    ADMINISTRATIVE_DETAIL: "Dettaglio amministrativo",
    ECONOMIC_DETAIL: "Dettaglio economico",
    TRANCHE_NUMBER: "N.Tranche",
    TRANCHE_IMPORT: "Importo Tranche",
    TRANCHE_IMPORT_EMPLOYEE: "Importo tranche dipendente",
    DAYS_NUMBER: "N. giornate",
    PAYMENT_TERM: "Termine di pagamento",
    VIEW_DEAL: "Visualizza offerta",
    DEAL_TYPE: "Tipologia offerta",
    BILLING_FREQUENCIES: "Frequenze di fatturazione",
    PAYMENTS_MEASURE_UNIT: "Unità di misure pagamenti",
    CUSTOMER_APPROVAL: "Richiede benestare del cliente?",
    ESTIMATED_COST: "Costo presunto",
    EFFECTIVE_COST: "Costo effettivo",
    ESTIMATED_REVENUE: "Fatturato presunto",
    EFFECTIVE_REVENUE: "Fatturato effettivo",
    PERCENTAGE_MARGIN: "Margine %",
    EURO_MARGIN: "Margine €",
    CREATE_COMMISSION: "Crea commessa",
    SHOW_IN_THE_TABLE: "Mostra nella tabella",
    ADD_ROW_TABLE: "Aggiungi riga tabella",
    COLUMNS_SHOWED_TABLE: "La colonna sarà presente nel documento, clicca per renderla invisibile",
    COLUMNS_NOT_SHOWED_TABLE: "La colonna non sarà presente nel documento, clicca per renderla visibile",
    DURATION_SINGLE: "Durata",
    SINGLE_AMOUNT: "Importo",
    EFFORT: "Effort",
    NO_ORDER_FILE_SELECTED: "Nessun documento ordine caricato.",
    NO__ORDER_ATTACHMENTS_SELECTED: "Nessuna documentazione caricata.",
    DOCUMENT_ORDER: "Documento ordine",
    ATTACHMENTS_ORDER: "Altra documentazione",
    CLOSE_COMMISSION: "Chiudi commessa",
    REOPEN_COMMISSION: "Riapri commessa",
    INSERT_NOTE: "Inserisci nota",
    NOT_STARTED: "Non avviato",
    ACTIVATED_MASCULIN: "Attivo",
    RENOVATED: "Rinnovato",
    EXPIRED: "Scaduto",
    TYPE_ORDER: "Tipologia ordine",
    SELECT_COMMISSION: "Seleziona commessa",
    STATE_ROUND: "Stato round",
    STATE_COMMISSION: "Stato commessa",
    CUSTOMER_AND_PROTOCOLLO: "Cliente / Protocollo",
    TOTAL_ABBREVIATION: "Tot.",
    EDIT_DESCRIPTION: "Modifica descrizione",
    ROUND: "Round",
    INSERT_TO_EXISTING_COMMISSION: "Aggiungi round a commessa esistente",
    DISCOUNT_PROPOSED_TO_CUSTOMER: "Sconto",
    NOT_DISCOUNTED: "Non scontato",
    DETAIL_NEW_ROUND: "Dettaglio nuovo round",
    ORDER_DESCRIPTION: "Descrizione ordine",
    BARGAINING_STEP: {
      BARGAINING: "Contrattazione",
      SEND_MASTERDATA: "Richiedi dati anagrafici",
      APPROVE_MASTERDATA: "Approva dati anagrafici",
      SEND_CONTRACT: "Invia contratto",
      APPROVE_CONTRACT: "Contratto da approvare",
      OK: "Completata",
      KO: "Disabilita"
    },
    BARGAINING: "Contrattazione",
    HAS_ORDER: "Ordine presente",
    HAS_NOT_ORDER: "Ordine non presente",
    SEND_EMAIL_CREDENTIALS: "Invia credenziali email aziendale",
    TOTAL_WORKED_HOURS: "Totale ore lavorate",
    HOURS_TO_ALLOCATE: "ore da assegnare",
    MISSING_SOME_HOURS_TO_ALLOCATE: "Mancano ancora delle ore da assegnare",
    _HOURS_ALLOCATED_TO_: " ore assegnate a ",
    _EXTRA_HOURS_ALLOCATED_TO_: " ore di extra assegnate a ",
    _AS_: " come ",
    ASSIGN_HOURS: "Assegna ore",
    EXTRA_HOURS_TO_ASSIGN: "Ore da assegnare",
    CANCELED_FEMALE: "Annullata",
    ENABLE: "Abilita",
    ORDERS: "Ordini",
    NEW_INVOICE: "Nuova fattura",
    CREATE_INVOICE: "Crea fattura",
    COMMISSION: "Commessa",
    CUSTOMER_APPROVAL_ABBREVIAITON: "Benestare",
    BILLING_FREQUENCY_ABBREVATION: "Frequenza",
    ORDER_NUMBER_ABBREVIATION: "N.ordine (cliente)",
    ESTIMATED_AMOUNT: "Imp. presunto",
    INVOICE_NUMBER: "Numero fattura",
    CREDIT_NOTE: "Nota di credito",
    INVOICE: "Fattura",
    USER_NOT_SENDED_REPORT: "Rapportino non presente per uno o più dipendenti",
    INVOICE_DOCUMENT: "Documento fattura",
    CREDIT_NOTE_DOCUMENT: "Documento nota di credito",
    INVOICE_ATTACHMENTS: "Allegati fattura",
    TYPEOLOGY_DOCUMENT: "Tipologia documento",
    SELECTED_MONTH: "Mese selezionato",
    UNIQUE_INVOICE: "Unica fattura",
    INVOICE_DETAIL: "Dettaglio fattura",
    COMPILE_FILEDS_CORRECTLY: "Compila correttamente i campi contrassegnati da ",
    INVOICE_MODAL_MESSAGE:
      "Attenzione per la fattura selezionata sono presenti altre fatture in mesi diversi.\n" + "                    Con il checkbox accanto al nome del mese puoi scegliere se includere il mese nella fattura.",
    ATTACHMENT: "Allegato",
    DOCUMENTS_AND_ATTACHMENTS: "Documenti e allegati",
    RELESEAD_ON_FEMALE: "Emessa il",
    OTHER_ATTACHMENTS: "Altri allegati",
    INVOICE_DATE: "Data fattura",
    VAT: "IVA",
    ADD_NEW_BANK: "Aggiungi nuova banca",
    EDIT_BANK: "Modifica banca",
    BANK: "Banca",
    BIC: "BIC",
    SWIFT: "SWIFT",
    VIEW_NOTES: "Visualizza note",
    MONTH_VALUE: "Valore in mesi",
    DESCRIPTION_CANON: "Canone verrà utilizzato per calcolare l'importo",
    IS_A_DETACHMENT: "È un distacco?",
    DETACHMENT_TYPE: "Tipo di distacco",
    DETACHMENT_DETAIL: "Dettaglio distacco",
    DETACHMENT: "Distacco",
    EMPLOYEES_DETAIL: "Dettaglio dipendenti",
    APPROVALS: "Benestari",
    ADD_EXTRA: "Aggiungi extra",
    REMOVE_EXTRA: "Rimuovi extra",
    CUT_FROM_RESIDUE: "Scalare dal residuo?",
    EXTRA_AMOUNT: "Importo extra",
    EMPLOYEE_AMOUNT: "Importo dipendente",
    DAYS_VALUE: "Valore in giorni",
    PAYMENT_END_MONTH: "Pagamento a fine mese?",
    CREATE_DETACHMENT: "Crea distacco",
    HOURS_RATE: "Tariffa oraria",
    INVOICE_TOTAL: "Importo totale fattura",
    AMOUNT_MONTH: "Importo mese di ",
    NOT_RECIVED_APPROVAL: "Benestare non ricevuto",
    INSERT_APPROVAL: "Clicca qui per registrare la ricezione del benestare",
    SET_CASHED: "Imposta come incassata",
    SET_AS_COMPLETED: "Imposta come completata",
    CASHED_DATE: "Incassata il",
    ADD_CREDIT_NOTE: "Aggiungi nota di credito",
    DOCUMENT_CREDIT_NOTE: "Documento nota di credito",
    CREDIT_NOTE_DATE: "Data nota di credito",
    DETAIL_CREDIT_NOTE: "Dettaglio nota di credito",
    CREDIT_NOTE_NUMBER: "Numero nota di credito",
    EMIT_INVOICE: "Emetti fattura",
    BILL_RESIDUE: "Fattura residuo",
    ALERT_RESIDUAL_PASSED_MESSAGE:
      "L'importo della fattura attualmente supera il residuo dell'ordine. <br> " +
      "Ti invitiamo a prendere una decisione tramite i tasti in basso. <br><br> " +
      "<strong>\"Emetti fattura\":</strong> l'importo attuale della fattura andrà a scalare il residuo dell'ordine. <br><br>" +
      "<strong>\"Fattura residuo\":</strong> la fattura che emetterai avrà l'importo residuo dell'ordine. <br>" +
      "Il sistema provvederà a creare una nuova fattura con l'importo eccedente di ",
    ALERT_RESIDUAL_PASSED_MESSAGE_CONTINUE: "<strong>\"Annulla\":</strong> torneai alla modifica della fattura.",
    AUTOMATIC_INVOICE: "Fatture create dal sistema",
    MANUAL_INVOICE: "Fatture create manualmente",
    EMITTED_BY_SYSTEM: "(Creata dal sistema)",
    CLOSE_ROUND: "Chiudi round",
    OPEN_ROUND: "Apri round",
    OPEN_ORDER: "Apri ordine",
    CLOSE_MASCULIN: "Chiuso",
    RECIVED: "Ricevuto",
    NOT_RECIVED: "Non ricevuto",
    INVOICE_CREATED_BY_SYSTEM: "Fattura creata dal sistema",
    INVOICE_CREATED_MANUAL: "Fattura creata manualmente",
    ABSENCES_REQUEST: "Richieste di assenze",
    VIEW_ABSENCE: "Visualizza assenza",
    RECORD: "Record",
    LAST_UPDATE: "Ultimo aggiornamento",
    CHECK_DATA_AND_SEND: "Controlla ed invia i dati",
    YOUR_CONTRACT: "Contratto USER_LASTNAME con Nepta",
    PRIVATE_DOCUMENTATION_AND_CONTRACT_FILE: "Documentazione privata e contratto",
    CONTRACT_DETAILS: "Dettagli contratto",
    UPDATE_CONTRACT: "Modifica contratto",
    DEACTIVATED: "Inattiva",
    TFR_AMOUNT: "Importo TFR",
    VIEW_PREVIEW_CONTRACT: "Visualizza anteprima contratto",
    PRIMARY_EDUCATION: "Formazione in evidenza?",
    SEND_CONTRACT_INFO:
      "Ora attendi che il candidato invii il contratto firmato. In caso di errore per rinviare l'email di firma contratto clicca sul pulsante salva in basso a destra, ritorna in questa sezione e sposta lo step su invia contratto nuovamente",
    SEND_MASTERDATA_INFO: "Ora attendi che il candidato compili i dati anagrafici. In caso di errore per rinviare l'email di richiesta dei dati anagrafici clicca due volte sul nome del candidato qui in basso.",
    ASSIGNED_FEMALE: "Assegnata",
    NOT_ASSIGNED_FEMALE: "Non assegnata",
    CANDIDATE_TRANSFORMED_TO_EMPLOYEE: "Il candidato è stato trasformato a dipendente",
    COLLABORATOR_TRANSFORMED_TO_EMPLOYEE: "Il collaboratore è stato trasformato a dipendente",
    ESTIMATED_DAILY_COST: "Costo giornaliero stimato",
    CLEAR_CACHE: "Svuota la cache",
    CLEAR_CACHE_EXPLICATION: "Inserisci l' url della chiamata (endpoint finale) su cui svuotare la cache",
    INSERT_END_POINT_URL: "Inserisci la path finale dell' url. Es: /deal",
    GENERATE_PDF_DOCUMENT: "Genera PDF",
    MANAGE_DOCUMENT: "Gestione documento",
    OFFER_OBJCET: "Offerta per la fornitura di assistenza specialistica",
    GENERATE: "Genera",
    ACTIVITY_PLACEHOLDER: "Scrivi qui le attività",
    PLATFORM_MAINTENACE_LOGIN_MESSAGE: "È in corso una manutenzione dalle",
    PLATFORM_MAINTENACE_LOGIN_MESSAGE_CONCLUSION: "Ti invitiamo ad effettuare il login più tardi.",
    DEVELOPER_TEAM: "Il team di sviluppo",
    PLACEHOLDER: {
      SELECT_CUSTOMER: "Seleziona un cliente",
      INSERT_NAME: "Inserisci un nome",
      SELECT_TYPE: "Seleziona un tipo",
      SELECT_SITE: "Seleziona una sede",
      SELECT_REFERENT: "Seleziona un referente",
      SELECT_ONE_OR_MORE_EMPLOYEE: "Seleziona uno o più dipendenti",
      SELECT_COMMERCIAL: "Seleziona un commerciale",
      SELECT_BILLING_FREQUENCY: "Seleziona una frequenza di fatturazione",
      INSERT_TRANCHE_NUMBER: "Inserisci un numero di tranche"
    },
    VIEW_CV: "Visualizza CV",
    SAVE_DOTS: "Salvo...",
    EDIT_DOTS: "Modifico...",
    SUMMARY: "Riepilogo",
    OPENING_DESCRIPTION: "Descrizione di apertura",
    CLOSURE_DESCRIPTION: "Descrizione di chiusura",
    RESIGNATION_DATE: "Data dimissioni",
    REMOVE_ROLES_FILTER: "Rimuovi filtri",
    TODAY: "oggi",
    TOMORROW: "domani",
    OF_THE: "del",
    COMMISSION_NAME: "Nome commessa",
    DEAL_NAME: "Nome offerta",
    COST_INDETERMINATE_DETERMINATE: "Costi indeterminato e determinato",
    COST__APPRENTICESHIP: "Costi apprendistato",
    CALCULATE_COST: "Calcola costi",
    COST_GENERATED_CONTRACT: "Costi contratto generato",
    CALCULATE: "Calcola",
    INDETERMINATE: "Indeterminato",
    APPRENTICESHIP: "Apprendistato",
    CUSTOMER_DETAIL: "Dettaglio cliente",
    ECONIMC_STATS: "Statistiche economiche",
    TOTAL_COSTS: "Tot. costi",
    TOTAL_REVENUE: "Tot. fatturato",
    DESCRIPTION_MONTHLY_CANON: "Canone mensile verrà utilizzato per calcolare l'importo",
    HOURS_ALLOCATED_COMMISSIONS: "Ore allocate commesse",
    ACCEPT_NEW_DATE: "Accetta la nuova data",
    ORIGINAL_CLOUSURE_ROUND: "Chiusura originale round precedente",
    NEW_CLOUSURE_ROUND: "Nuova chiusura round precedente",
    DOCUMENTATION: "Documentazione",
    MONTHLY_IMPORT: "Importo mensile",
    MONTH_ACTIVITY: "Mesi di attività",
    ROUND_DESCRIPTION: "Descrizione round",
    DOWNLOAD_DOCUMENT: "Scarica documento",
    CREATE: "Crea",
    GENERATE_INVOICE: "Genera fatture",
    GENERATE_INVOICE_EXPLICATION: "Le fatture che andrai a generare per il mese selezionato non andranno a sostituire le fatture già emesse.",

    EXTERNAL_ADDRESS_QUESTION: "Indirizzo estero?",
    ACTIVITY_DETAIL: "Dettaglio attività",
    REMOVE_EMPLOYEE: "Rimuovi dipendente",
    PLACE_SINGULAR: "Sede",
    REFERENT: "Referente",
    TOTAL_PERCENTAGE_MARGIN: "Totale margine %",
    TOTAL_EURO_MARGIN: "Totale margine €",
    COMMISSIONS_NUMBER: "Numero commesse",
    EMPLOYEEE_HAS_COMMISSION_NUMBER: "Il dipendente ha incarico ",
    EMPLOYEEE_HAS_COMMISSION_NUMBER_SECOND: " commesse per questo mese",
    SLECTABLE_COLUMNS: "Colonne selezionabili",
    SELECTED_COLUMNS: "Colonne selezionate",
    NO_SELECTED_FIELDS: "Nessun campo selezionato",
    SELECT_EXPORT_TEMPLATE: "Seleziona un template di esportazione",
    TYPE_NEW_EXPORT_TEMPLATE_NAME_AND_PRESS_ENTER_TO_SAVE: "Digita il nome del nuovo template di esportazione e premi invio per salvare",
    EXPORT_TEMPLATE_NAME: "Nome template di esportazione",
    EMPLOYEES_AND_PRODUCTS: "Dipendenti/prodotti",
    LEGEND_TABLECONTENT: "Per poter visualizzare la tabella sul documento generato devi inserire nel editor sovrastante la parola %TABLECONTENT%",
    CLEAR_DATE: "Svuota le date",
    PRODUCT_COMMISSION: "Commessa di prodotto",
    SEARCH_FEATURE_OPTION: "Cerca opzione funzionalità",
    CREATON_DATE: "Data di creazione",
    FILTER_BY_YEAR: "Filtra per anno",
    WORKING_DAYS: "Giorni lavorativi",
    FILTER_BY_MONTH_AND_YEAR: "Filtra per mese e anno",
    FIGURE_ID: "Figura",
    FISCALCODE: "Codice fiscale",
    TUTOR_HASH: "Tutor",
    PROVIDER_ID: "Fornitore",
    LOADING_USER_COMMISSIONS: "Caricamento commesse dipendente",
    REFRESH_ANALYTIC: "Rigenera i calcoli economici per questo mese.",
    REGENERATE_CALCULATE_ECONOMIC: "Rigenera calcolo",
    NOT_HAS_PRIVATE_EMAIL: "Email privata non presente",
    NOT_HAS_COMPANY_EMAIL: "Email aziendale non presente",
    SEARCH_USER: "Cerca dipendente",
    COST_ALLOCATION: "Imputazione costi",
    DUPLICATE_OFFER: "Duplica offerta",
    PROVIDER_COST: "Costo fornitore",
    ADD_ORDER: "Aggiungi ordine",
    CAPACITY_ORDER: "Capienza ordine",
    RESIDUE_ORDER: "Residuo ordine",
    SECONDARY_ORDERS: "Ordini secondari",
    SECONDARY_ORDER: "Ordine secondario",
    TOTAL_CAPACITY: "Capienza totale",
    TOTAL_RESIDUE: "Residuo totale",
    EDIT_ORDER: "Modifica ordine",
    CCNL: "CCNL",
    ALL_CITIES: "Tutte le città",
    RESIDUAL_PREV_ROUNDS: "Residuo da round precedente/i:",
    NO_PRODUCT_COMMISSION_FOR_THIS_CLIENT: "Nessuna commessa di prodotto per questo cliente",
    CLOSE_DETAIL: "Chiudi dettaglio",
    UPLOAD_DOCUMENT_FROM_PREV_ORDER: "Carica documento da ordine precedente",
    EMPLOYEE_STANDBY_COMMISSION: "Dipendenti fermi",
    RATING: "Giudizio",
    BRILLIANT: "Brillante",
    SUFFICIENT: "Sufficiente",
    NOT_PREPERED: "Non preparato",
    BLACKLIST: "Black List",
    SELECT_SKILL: "Seleziona skill",
    COPY_FROM_PREV_ORDER: "Copia dati da ordine precedente",
    ECONOMIC_GRAPH: "Grafico economico",
    COLOR: "Colore",
    PLANNING: "Planning",
    NO_DATA_TO_COMPARE: "Nessun dato per creare il grafico.",
    PRODUCTION_BONUS: "Premio produzione annuo",
    EMPLOYEE_CV: "CV dipendente",
    CV_AS_CANDIDATE: "CV da candidato",
    DUPLICATE_ROUND: "Duplica round",
    EDIT_COMPANY_EMAIL: "Modifica email aziendale",
    EXPIRE_MONTH: "Mese di scadenza",
    SELECT_EXPIRE_MONTH: "Seleziona mese di scadenza",
    DETACHMENT_FILTER: "Filtro distacco",
    TYPE_ORDER_FILTER: "Filtro tipo ordine",
    ORDER_TYPE: "Tipo ordine",
    FILTER_STATE_COMMISSION: "Filtro stato commessa",
    FILTER_ORDER: "Filtro ordine",
    FILTER_STATE_ROUND: "Filtro stato round",
    RESOURCES: "Risorse",
    ORIGINAL_END_DATE: "Data fine originale",
    PAYMENT_TYPE: "Tipo di pagamento",
    REMOVE_FILTER: "Rimuovi filtro",
    NO_DOCUMENT_ATTACHED: "Nessun documento allegato",
    ATTACHMENT_FOR_ORDER: "Allegato ordine",
    PROFILE_LAST_UPDATE_DATE: "Profilo aggiornato il",
    FROM_MONTH: "Dal mese",
    FROM_YEAR: "Dall'anno",
    TO_MONTH: "Al mese",
    TO_YEAR: "All'anno",
    TOTAL_STRUCTURE_COST: "Costi struttura",
    TOTAL_PROVIDER_COST: "Costi fornitori",
    TOTAL_COMMISSION_REAL_COST: "Costi commesse",
    TOTAL_PROFIT: "Fatturato",
    TOTAL_COST: "Totale costi",
    MONTH_YEAR: "Mese e anno",
    REGENERATE: "Rigenera",
    REGENERATE_ANALYTICS: "Rigenera dettagli economici",
    REGENERATE_MONTLY_AND_YEARLY_ANALYTICS: "Selezionando mese ed anno potrai rigenerare tutti i dettagli economici di tutte le commesse di tutti i round attivi in quel mese ed anno.",
    TOTAL_PROFIT_PERTINENT: "Fatturato di pertinenza",
    TOTAL_RESIDUE_PROFIT_PERTINENT: "Fatturato residuo di pertinenza",
    UNLOCK_WORKDAY_REPORT: "Sblocca rapportino",
    EXPIRED_AND_NOT_CASHED: "Scadute e non incassata",
    LINK_TO_ECONOMIC_DETAIL: "Collega ad un dettaglio economico",
    USE_AS_DEFAULT: "Usa come default",
    LASTNAME_AND_FIRSTNAME: "Cognome e nome",
    SEARCH_BY_NAME: "Cerca per nome o cognome",
    ALL_MONTHS: "Tutti i mesi",
    DOCUMENTED_COSTS: "Rimborsi spese documentate",
    ORDER_RESIDUE: "Residuo ordine"
  }
};
